webpackJsonp([1],{

/***/ "+2Sp":
/***/ (function(module, exports) {

module.exports = [{"classNo":"1100","classDesc":"自強","classColor":"red","classFare":"成自"},{"classNo":"1101","classDesc":"自強","classColor":"red","classFare":"成自"},{"classNo":"1102","classDesc":"太魯閣","classColor":"blue","classFare":"成自"},{"classNo":"1103","classDesc":"自強","classColor":"red","classFare":"成自"},{"classNo":"1106","classDesc":"自強","classColor":"red","classFare":"成自"},{"classNo":"1107","classDesc":"普悠瑪","classColor":"pink","classFare":"成自"},{"classNo":"1108","classDesc":"自強","classColor":"red","classFare":"成自"},{"classNo":"1109","classDesc":"自強","classColor":"red","classFare":"成自"},{"classNo":"110A","classDesc":"自強","classColor":"red","classFare":"成自"},{"classNo":"110B","classDesc":"自強","classColor":"red","classFare":"成自"},{"classNo":"110C","classDesc":"自強","classColor":"red","classFare":"成自"},{"classNo":"110D","classDesc":"自強","classColor":"red","classFare":"成自"},{"classNo":"110E","classDesc":"自強","classColor":"red","classFare":"成自"},{"classNo":"110F","classDesc":"自強","classColor":"red","classFare":"成自"},{"classNo":"1110","classDesc":"莒光","classColor":"orange","classFare":"成莒"},{"classNo":"1111","classDesc":"莒光","classColor":"orange","classFare":"成莒"},{"classNo":"1114","classDesc":"莒光","classColor":"orange","classFare":"成莒"},{"classNo":"1115","classDesc":"莒光","classColor":"orange","classFare":"成莒"},{"classNo":"1120","classDesc":"復興","classColor":"","classFare":"成復"},{"classNo":"1131","classDesc":"區間車","classColor":"","classFare":"成復"},{"classNo":"1132","classDesc":"區間快車","classColor":"grey","classFare":"成復"},{"classNo":"1140","classDesc":"普快車","classColor":"","classFare":"成普"}]

/***/ }),

/***/ "+OcR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Station_vue__ = __webpack_require__("LntH");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_afca796c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Station_vue__ = __webpack_require__("6u9G");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Station_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_afca796c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Station_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "0H84":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    'isNotEmpty': function isNotEmpty(value) {
        return !_.isEmpty(value);
    },
    'isNotNull': function isNotNull(value) {
        return !_.isNull(value);
    }
});

/***/ }),

/***/ "1PUk":
/***/ (function(module, exports) {

module.exports = [{"lineNo":"0","lineDesc":"","lineColor":""},{"lineNo":"1","lineDesc":"山線","lineColor":"green"},{"lineNo":"2","lineDesc":"海線","lineColor":"blue"}]

/***/ }),

/***/ "1ubc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui fluid card pointer"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"ui grid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"four wide column"},[_c('h3',{staticClass:"ui header",class:_vm.trainTypeColor(_vm.train.TrainInfo.TrainTypeCode)},[_vm._v("\n            "+_vm._s(_vm.train.TrainInfo.TrainTypeName.Zh_tw)+"\n            "),_c('div',{staticClass:"sub header"},[_vm._v(_vm._s(_vm.train.TrainInfo.TrainNo))])])]),_vm._v(" "),_c('div',{staticClass:"five wide column"},[_c('h5',{staticClass:"ui header center aligned"},[_c('div',{staticClass:"sub header"},[_vm._v("\n              "+_vm._s(_vm.train.TrainInfo.StartingStationName.Zh_tw)+"\n              "),_c('i',{staticClass:"arrow right icon inline-icon"}),_vm._v("\n              "+_vm._s(_vm.train.TrainInfo.EndingStationName.Zh_tw)+"\n            ")])])]),_vm._v(" "),_c('div',{staticClass:"four wide column"},[_c('div',{staticClass:"ui right floated"},[(_vm.train.TrainInfo.TripLine)?_c('div',{staticClass:"ui circular basic label",class:[_vm.tripLine(_vm.train.TrainInfo.TripLine, true)]},[_vm._v(_vm._s(_vm.tripLine(_vm.train.TrainInfo.TripLine)))]):_vm._e()])])])]),_vm._v(" "),_c('div',{staticClass:"description"},[_c('div',{staticClass:"ui grid"},[_c('div',{staticClass:"three wide column departure-time"},[_vm._v(_vm._s(_vm.train.StopTimes[0].DepartureTime))]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"three wide column"},[_vm._v(_vm._s(_vm.train.StopTimes[1].ArrivalTime))]),_vm._v(" "),_c('div',{staticClass:"five wide center aligned column"},[_vm._v(_vm._s(_vm.timeDiff( _vm.train.StopTimes[0].DepartureTime, _vm.train.StopTimes[1].ArrivalTime).humanize))]),_vm._v(" "),_c('div',{staticClass:"three wide right aligned column"},[(_vm.fares)?_c('p',[_vm._v(_vm._s("$ " + _vm.getFare(_vm.train.TrainInfo.TrainTypeCode)))]):_vm._e()])])])]),_vm._v(" "),_c('div',{staticClass:"extra content"},[_c('div',{staticClass:"ui basic grey horizontal medium label"},[_vm._v(_vm._s(_vm.train.StopTimes[1].StopSequence - _vm.train.StopTimes[0].StopSequence)+"站")]),_vm._v(" "),(_vm.train.TrainInfo.WheelChairFlag)?_c('div',{staticClass:"ui blue horizontal medium label"},[_vm._v("輪椅")]):_vm._e(),_vm._v(" "),(_vm.train.TrainInfo.BreastFeedFlag)?_c('div',{staticClass:"ui pink horizontal medium label"},[_vm._v("哺乳室")]):_vm._e(),_vm._v(" "),(_vm.train.TrainInfo.BikeFlag)?_c('div',{staticClass:"ui green horizontal medium label"},[_vm._v("自行車")]):_vm._e(),_vm._v(" "),(_vm.DMULabel(_vm.train.TrainInfo.Note.Zh_tw))?_c('div',{staticClass:"ui yellow horizontal medium label"},[_vm._v("柴聯")]):_vm._e(),_vm._v(" "),(_vm.overNightLabel(_vm.train.TrainInfo.OverNightStationID))?_c('div',{staticClass:"ui brown horizontal medium label"},[_vm._v("跨日")]):_vm._e(),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm._f("noteFormat")(_vm.train.TrainInfo.Note)))])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"two wide column"},[_c('i',{staticClass:"arrow right icon"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3eAj":
/***/ (function(module, exports) {

module.exports = [{"dateDefine":"大前天","dateValue":-3},{"dateDefine":"前天","dateValue":-2},{"dateDefine":"昨天","dateValue":-1},{"dateDefine":"今天","dateValue":0},{"dateDefine":"明天","dateValue":1},{"dateDefine":"後天","dateValue":2},{"dateDefine":"大後天","dateValue":3}]

/***/ }),

/***/ "57PL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TrainItemMobile_vue__ = __webpack_require__("M35L");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_582b71ad_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TrainItemMobile_vue__ = __webpack_require__("nUGc");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TrainItemMobile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_582b71ad_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TrainItemMobile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6u9G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui grid stackable container"},[(_vm._.isNull(_vm.station))?_c('Loading'):_vm._e(),_vm._v(" "),(_vm.station)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"ui sixteen wide column"},[_c('div',{staticClass:"ui red segment"},[_c('h2',{staticClass:"ui header"},[_vm._v("\n          "+_vm._s(_vm.station.StationName.Zh_tw)+"\n          "),_c('p',[_vm._v(_vm._s(_vm.station.StationName.En))]),_vm._v(" "),_c('div',{staticClass:"sub header"},[_vm._v("\n            "+_vm._s(_vm.query.dateHumanize)+"\n            "),(!_vm._.isEmpty(_vm.trains))?_c('span',[_vm._v("，共有 "+_vm._s(_vm.trains.length)+" 班列車")]):_vm._e(),_vm._v("。\n            "),(!_vm.query.isToday)?_c('a',{staticClass:"ui label",on:{"click":function($event){_vm.backToday()}}},[_c('i',{staticClass:"reply icon"}),_vm._v("回到今天\n            ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"ui list"},[_c('div',{staticClass:"item"},[_c('div',{staticClass:"ui orange horizontal label"},[_vm._v("電話")]),_vm._v("\n            "+_vm._s(_vm.station.StationPhone)+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"item"},[_c('div',{staticClass:"ui green horizontal label"},[_vm._v("地址")]),_vm._v("\n            "+_vm._s(_vm.station.StationAddress)+"\n          ")])]),_vm._v(" "),(_vm.query.isToday && _vm.trainsRendered)?_c('div',{staticClass:"ui toggle checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.hideDepartured),expression:"hideDepartured"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.hideDepartured)?_vm._i(_vm.hideDepartured,null)>-1:(_vm.hideDepartured)},on:{"change":function($event){var $$a=_vm.hideDepartured,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.hideDepartured=$$a.concat([$$v]))}else{$$i>-1&&(_vm.hideDepartured=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.hideDepartured=$$c}}}}),_vm._v(" "),_c('label',[_vm._v("隱藏已離站列車")])]):_vm._e()])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"ui sixteen wide column"},[_c('div',{staticClass:"ui two buttons"},[_c('div',{staticClass:"ui button",class:(_vm.direction == 0) ? 'active' : '',on:{"click":function($event){_vm.directionSwitch('0')}}},[_vm._v("順行")]),_vm._v(" "),_c('div',{staticClass:"ui button",class:(_vm.direction == 1 ) ? 'active' : '',on:{"click":function($event){_vm.directionSwitch('1')}}},[_vm._v("逆行")])])])]),_vm._v(" "),(_vm.station && _vm.trainsRendered)?_c('div',{staticClass:"computer tablet only row"},[_c('div',{staticClass:"ui sixteen wide column"},[(_vm._.isEmpty(_vm.trainsRendered))?_c('Loading'):_vm._e(),_vm._v(" "),_c('table',{staticClass:"ui selectable striped definition table"},[_vm._m(0),_vm._v(" "),_c('tbody',_vm._l((_vm.trainsRendered),function(train){return _c('TrainItem',{directives:[{name:"show",rawName:"v-show",value:((!_vm.query.isToday || !_vm.hideDepartured || !_vm.isDeparture( train.TrainInfo.DepartureTime ))),expression:"(!query.isToday || !hideDepartured || !isDeparture( train.TrainInfo.DepartureTime ))"}],key:train.TrainInfo.TrainNo,staticClass:"pointer",attrs:{"train":train},nativeOn:{"click":function($event){_vm.toTrainDetail(train)}}})}))])],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mobile only row"},[_c('div',{staticClass:"ui sixteen wide column"},_vm._l((_vm.trainsRendered),function(train){return _c('TrainItemMobile',{directives:[{name:"show",rawName:"v-show",value:((!_vm.query.isToday || !_vm.hideDepartured || !_vm.isDeparture( train.TrainInfo.DepartureTime ))),expression:"(!query.isToday || !hideDepartured || !isDeparture( train.TrainInfo.DepartureTime ))"}],key:train.TrainInfo.TrainNo,staticClass:"pointer",attrs:{"train":train},nativeOn:{"click":function($event){_vm.toTrainDetail(train)}}})}))])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('th',{staticClass:"two wide"},[_vm._v("詳細資料")]),_vm._v(" "),_c('th',{staticClass:"one wide center aligned"},[_c('h4',{staticClass:"ui header"},[_vm._v("\n              經由\n              "),_c('div',{staticClass:"sub header"},[_vm._v("Via")])])]),_vm._v(" "),_c('th',{staticClass:"two wide center aligned"},[_c('h4',{staticClass:"ui header"},[_vm._v("\n              開車時間\n              "),_c('div',{staticClass:"sub header"},[_vm._v("Departure")])])]),_vm._v(" "),_c('th',{staticClass:"two wide center aligned"}),_vm._v(" "),_c('th',{staticClass:"two wide center aligned"},[_c('h4',{staticClass:"ui header"},[_vm._v("\n              終點站\n              "),_c('div',{staticClass:"sub header"},[_vm._v("Destination")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7+I5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Briefing_vue__ = __webpack_require__("idTU");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e9af742c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Briefing_vue__ = __webpack_require__("THYD");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Briefing_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e9af742c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Briefing_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9pRa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TrainItem_vue__ = __webpack_require__("dR3Q");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ddbd7ee_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TrainItem_vue__ = __webpack_require__("wybN");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TrainItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ddbd7ee_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TrainItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "BBWr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      status: false
    };
  },

  methods: {
    /**
     * Get Repository status from Github API
     */
    getStatus: function getStatus() {
      var _this = this;

      axios.get('https://api.github.com/repos/banqhsia/tra-info/commits/master').then(function (response) {
        _this.status = response.data.commit;
      });
    }
  },
  mounted: function mounted() {
    this.getStatus();
  }
});

/***/ }),

/***/ "BCH6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"ui grid stackable container"},[_c('h2',{staticClass:"row"},[_c('div',{staticClass:"ui sixteen wide column"},[_c('router-link',{staticClass:"ui header pointer",attrs:{"tag":"h2","to":{name: 'Timetable'}}},[_c('img',{staticClass:"ui image rounded",attrs:{"src":"static/img/logo.png"}}),_vm._v(" "),_c('div',{staticClass:"content"},[_vm._v("\n            臺鐵資訊查詢\n            "),_c('div',{staticClass:"ui sub header"},[_vm._v("\n              TRA Information\n            ")])])])],1)]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"ui sixteen wide column"},[_c('div',{staticClass:"ui tabular menu"},[_c('router-link',{staticClass:"item",attrs:{"to":{ name: 'Timetable' }}},[_vm._v("時刻表查詢")]),_vm._v(" "),_c('router-link',{staticClass:"item",attrs:{"to":{ name: 'Station' }}},[_vm._v("車站資訊查詢")]),_vm._v(" "),_c('router-link',{staticClass:"item",attrs:{"to":{ name: 'About' }}},[_vm._v("關於")])],1)])])]),_vm._v(" "),_c('router-view'),_vm._v(" "),_vm._m(1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"ui computer tablet only sixteen wide column"},[_c('div',{staticClass:"fb-like",attrs:{"data-href":"https://www.facebook.com/TRAInformation/","data-layout":"standard","data-action":"like","data-size":"small","data-show-faces":"false","data-share":"true"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui grid stackable container"},[_c('div',{staticClass:"ui sixteen wide column"},[_c('div',{staticClass:"ui divider"}),_vm._v("\n      臺鐵資訊查詢\n      "),_c('div',[_vm._v("TRA INFORMATION")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "BfgB":
/***/ (function(module, exports) {

module.exports = [{"classDef":["傾斜式","傾斜式列車"],"classDetail":{"list":[1102,1107],"desc":"傾斜式列車"}},{"classDef":["普悠瑪","普悠瑪號","番鴨","紅番鴨","puyuma"],"classDetail":{"list":[1107],"desc":"普悠瑪號"}},{"classDef":["太魯閣","太魯閣號","滷蛋","太魯蛋","taroko"],"classDetail":{"list":[1102],"desc":"太魯閣號"}},{"classDef":["自強","自強號","快快","快車","tc"],"classDetail":{"list":[1100,1101,1102,1103,1107,1108],"desc":"自強號"}},{"classDef":["莒光","莒光號","中中","ck"],"classDetail":{"list":[1110,1111,1114,1115],"desc":"莒光號"}},{"classDef":["區間","區間車","復興","復興號","普通車","普通","電車","阿福","阿福號","每站停","慢慢","慢車","lt","local"],"classDetail":{"list":[1120,1131,1132,1140],"desc":"區間車"}},{"classDef":["區間快","區間快車","區快"],"classDetail":{"list":[1132],"desc":"區間快車"}},{"classDef":["普快車","普快"],"classDetail":{"list":[1140],"desc":"普快車"}},{"classDef":["對號","對號車","對號列車","椅子","座位","坐票","seat"],"classDetail":{"list":[1102,1107,1100,1101,1102,1103,1107,1108,1110,1111,1114,1115],"desc":"對號列車"}},{"classDef":["非對號","非對號車","非對號列車","站票","無座"],"classDetail":{"list":[1120,1131,1140],"desc":"非對號列車"}}]

/***/ }),

/***/ "Bjt9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui green message"},[_c('div',{staticClass:"header"},[_vm._v("請輸入關鍵字查詢列車時刻")]),_vm._v(" "),_c('p',[_vm._v("輸入起迄站、時間、車種即可。「中壢 新竹」「鳳山 新左營 11/7」「台北 花蓮 太魯閣」「嘉義 民雄 星期四 莒光」")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Bzo/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["history"]
});

/***/ }),

/***/ "FElo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui grid stackable container"},[(_vm.status == 'loading')?_c('Loading'):_vm._e(),_vm._v(" "),_c('div',{staticClass:"ui three wide column"},[_c('router-link',{staticClass:"ui fluid icon button left floated",attrs:{"tag":"button","to":{name: 'Timetable'}}},[_c('i',{staticClass:"chevron left icon"}),_vm._v(" 返回查詢\n    ")])],1),_vm._v(" "),(_vm.status == false)?_c('div',{staticClass:"row"},[_vm._m(0)]):_vm._e(),_vm._v(" "),(_vm.status == true)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"ui sixteen wide column"},[_c('div',{staticClass:"ui segment",class:_vm.trainTypeColor(_vm.train.TrainInfo.TrainTypeCode)},[_c('h2',{staticClass:"ui header"},[_vm._v("\n          "+_vm._s(_vm.train.TrainInfo.TrainNo)+" "+_vm._s(_vm.train.TrainInfo.TrainTypeName.Zh_tw)+"\n          "),_c('div',{staticClass:"sub header"},[_vm._v("\n            "+_vm._s(_vm.query.dateHumanize)+"，\n            "),_c('router-link',{attrs:{"to":{
              name: 'Station.view',
              params: {
                station: _vm.train.TrainInfo.StartingStationID,
                date: _vm.query.date
              }
            }}},[_c('b',[_vm._v(_vm._s(_vm.train.TrainInfo.StartingStationName.Zh_tw))])]),_vm._v(" 到\n            "),_c('router-link',{attrs:{"to":{
              name: 'Station.view',
              params: {
                station: _vm.train.TrainInfo.EndingStationID,
                date: _vm.query.date
              }
            }}},[_c('b',[_vm._v(_vm._s(_vm.train.TrainInfo.EndingStationName.Zh_tw))])])],1)]),_vm._v(" "),(_vm.train.TrainInfo.TripLine)?_c('div',{staticClass:"ui circular horizontal basic label",class:[_vm.tripLine(_vm.train.TrainInfo.TripLine, true)]},[_vm._v(_vm._s(_vm.tripLine(_vm.train.TrainInfo.TripLine)))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"ui basic grey horizontal medium label"},[_vm._v(_vm._s(_vm.train.StopTimes.length)+"站")]),_vm._v(" "),(_vm.train.TrainInfo.WheelChairFlag)?_c('div',{staticClass:"ui blue horizontal medium label"},[_vm._v("輪椅")]):_vm._e(),_vm._v(" "),(_vm.train.TrainInfo.BreastFeedFlag)?_c('div',{staticClass:"ui pink horizontal medium label"},[_vm._v("哺乳室")]):_vm._e(),_vm._v(" "),(_vm.train.TrainInfo.BikeFlag)?_c('div',{staticClass:"ui green horizontal medium label"},[_vm._v("自行車")]):_vm._e(),_vm._v(" "),(_vm.DMULabel(_vm.train.TrainInfo.Note.Zh_tw))?_c('div',{staticClass:"ui yellow horizontal medium label"},[_vm._v("柴聯")]):_vm._e(),_vm._v(" "),(_vm.overNightLabel(_vm.train.TrainInfo.OverNightStationID))?_c('div',{staticClass:"ui brown horizontal medium label"},[_vm._v("跨日")]):_vm._e(),_vm._v("\n        "+_vm._s(_vm._f("noteFormat")(_vm.train.TrainInfo.Note))+"\n      ")])])]):_vm._e(),_vm._v(" "),(_vm.status == true)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"ui sixteen wide column"},[_c('table',{staticClass:"ui unstackable basic definition table"},[_vm._m(1),_vm._v(" "),_c('tbody',_vm._l((_vm.train.StopTimes),function(item,$index){return _c('tr',{key:item.StationID},[_c('td',[_c('h4',{staticClass:"ui header"},[_c('i',{staticClass:"icon grey"},[_vm._v(_vm._s($index+1))]),_vm._v(" "),_c('router-link',{staticClass:"content pointer",attrs:{"tag":"div","to":{
                  name: 'Station.view',
                  params: {
                    station: item.StationID,
                    date: _vm.query.date
                  }
                }}},[_vm._v("\n                  "+_vm._s(item.StationName.Zh_tw)+"\n                  "),_c('div',{staticClass:"sub header"},[_vm._v(_vm._s(item.StationName.En))])])],1)]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.ArrivalTime))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.DepartureTime))]),_vm._v(" "),($index)?_c('td',[_vm._v(_vm._s(_vm.timeDiff(_vm.train.StopTimes[$index-1].DepartureTime, item.ArrivalTime).humanize || ''))]):_vm._e()])}))])])]):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui sixteen wide column"},[_c('div',{staticClass:"ui red message"},[_c('div',{staticClass:"header"},[_vm._v("查無列車資料")]),_vm._v(" "),_c('p',[_vm._v("這個時間點，或是你指定的車次，找不到任何列車的資訊。")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"four wide"},[_vm._v("詳細資料")]),_vm._v(" "),_c('th',{staticClass:"four wide"},[_c('h4',{staticClass:"ui header"},[_vm._v("\n                抵達時間\n                "),_c('div',{staticClass:"sub header"},[_vm._v("Arrival")])])]),_vm._v(" "),_c('th',{staticClass:"four wide"},[_c('h4',{staticClass:"ui header"},[_vm._v("\n                開車時間\n                "),_c('div',{staticClass:"sub header"},[_vm._v("Departure")])])]),_vm._v(" "),_c('th',{staticClass:"four wide"},[_c('h4',{staticClass:"ui header"},[_vm._v("\n                行車時間\n                "),_c('div',{staticClass:"sub header"},[_vm._v("Travel Time")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FVEL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui grid stackable container"},[(_vm.status == 'loading')?_c('Loading'):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"ui sixteen wide column"},[_c('div',{staticClass:"ui form"},[_c('div',{staticClass:"field"},[_c('div',{staticClass:"ui left action icon input"},[_c('button',{staticClass:"ui icon button",on:{"click":function($event){_vm.searchEmpty()}}},[_c('i',{staticClass:"trash icon"})]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.input.keyword),expression:"input.keyword",modifiers:{"trim":true}}],ref:"keyword",attrs:{"type":"text","placeholder":"中壢 台北 明天 自強號","disabled":_vm.status == 'loading'},domProps:{"value":(_vm.input.keyword)},on:{"keypress":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.search()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.input, "keyword", $event.target.value.trim())},"blur":function($event){_vm.$forceUpdate()}}}),_vm._v(" "),_c('i',{staticClass:"inverted circular search link icon",on:{"click":function($event){_vm.search()}}})])]),_vm._v(" "),(_vm._.isNotEmpty(_vm.history))?_c('History',{attrs:{"history":_vm.history},on:{"historyLabelClicked":_vm.search}}):_vm._e()],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"ui sixteen wide column"},[(!_vm.trains && _vm.status != false && _vm.status != 'loading')?_c('SearchTips'):_vm._e(),_vm._v(" "),(_vm.status == false && _vm.status != 'loading')?_c('SearchError'):_vm._e(),_vm._v(" "),(_vm.trains)?_c('Briefing',{attrs:{"query":_vm.query,"trains":_vm.trains,"fares":_vm.fares,"trainClassMap":_vm.trainClassMap,"trainsResponseCount":_vm.trainsResponse.length},on:{"trainTypeClicked":_vm.setTrainClassMap,"trainClassMapCrossClicked":_vm.clearFilter}}):_vm._e(),_vm._v(" "),(_vm.query.isToday && _vm.trains)?_c('div',{staticClass:"ui toggle checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.hideDepartured),expression:"hideDepartured"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.hideDepartured)?_vm._i(_vm.hideDepartured,null)>-1:(_vm.hideDepartured)},on:{"change":function($event){var $$a=_vm.hideDepartured,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.hideDepartured=$$a.concat([$$v]))}else{$$i>-1&&(_vm.hideDepartured=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.hideDepartured=$$c}}}}),_vm._v(" "),_c('label',[_vm._v("隱藏已離站列車")])]):_vm._e()],1)]),_vm._v(" "),(_vm.trains)?_c('div',{staticClass:"computer only row"},[_c('div',{staticClass:"ui sixteen wide column"},[_c('table',{staticClass:"ui selectable striped definition table"},[_c('thead',[_c('tr',[_c('th',{staticClass:"two wide"}),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('th',{staticClass:"two wide center aligned"},[_c('h4',{staticClass:"ui header pointer",on:{"click":function($event){_vm.setOrderBy('StopTimes[0].DepartureTime')}}},[_c('i',{staticClass:"icon sort",class:[ _vm.orderByClass('StopTimes[0].DepartureTime') ]}),_vm._v(" "),_vm._m(1)])]),_vm._v(" "),_c('th',{staticClass:"two wide center aligned"},[_c('h4',{staticClass:"ui header pointer",on:{"click":function($event){_vm.setOrderBy('TravelTime.value')}}},[_c('i',{staticClass:"icon sort",class:[ _vm.orderByClass('TravelTime.value') ]}),_vm._v(" "),_vm._m(2)])]),_vm._v(" "),_c('th',{staticClass:"two wide center aligned"},[_c('h4',{staticClass:"ui header pointer",on:{"click":function($event){_vm.setOrderBy('StopTimes[1].ArrivalTime')}}},[_c('i',{staticClass:"icon sort",class:[ _vm.orderByClass('StopTimes[1].ArrivalTime') ]}),_vm._v(" "),_vm._m(3)])]),_vm._v(" "),_vm._m(4),_vm._v(" "),(_vm.delay)?_c('th',{staticClass:"one wide"},[_vm._m(5)]):_vm._e(),_vm._v(" "),_vm._m(6)])]),_vm._v(" "),_vm._l((_vm.trains),function(train){return _c('TrainItem',{directives:[{name:"show",rawName:"v-show",value:((!_vm.query.isToday || !_vm.hideDepartured || !_vm.isDeparture( train.StopTimes[0].DepartureTime ))),expression:"(!query.isToday || !hideDepartured || !isDeparture( train.StopTimes[0].DepartureTime ))"}],key:train.TrainInfo.TrainNo,staticClass:"pointer",attrs:{"train":train,"fares":_vm.fares},nativeOn:{"click":function($event){_vm.toTrainDetail(train)}}})})],2)])]):_vm._e(),_vm._v(" "),(_vm.trains)?_c('div',{staticClass:"mobile tablet only row"},[_c('div',{staticClass:"ui sixteen wide column"},[_c('div',{staticClass:"ui small three item menu"},[_c('div',{staticClass:"item"},[_c('h5',{staticClass:"ui header pointer",on:{"click":function($event){_vm.setOrderBy('StopTimes[0].DepartureTime')}}},[_c('i',{staticClass:"icon mini sort",class:[ _vm.orderByClass('StopTimes[0].DepartureTime') ]}),_vm._v(" "),_vm._m(7)])]),_vm._v(" "),_c('div',{staticClass:"item"},[_c('h5',{staticClass:"ui header pointer",on:{"click":function($event){_vm.setOrderBy('TravelTime.value')}}},[_c('i',{staticClass:"icon mini sort",class:[ _vm.orderByClass('TravelTime.value') ]}),_vm._v(" "),_vm._m(8)])]),_vm._v(" "),_c('div',{staticClass:"item"},[_c('h5',{staticClass:"ui header pointer",on:{"click":function($event){_vm.setOrderBy('StopTimes[1].ArrivalTime')}}},[_c('i',{staticClass:"icon mini sort",class:[ _vm.orderByClass('StopTimes[1].ArrivalTime') ]}),_vm._v(" "),_vm._m(9)])])]),_vm._v(" "),_vm._l((_vm.trains),function(train){return _c('TrainItemMobile',{directives:[{name:"show",rawName:"v-show",value:((!_vm.query.isToday || !_vm.hideDepartured || !_vm.isDeparture( train.StopTimes[0].DepartureTime ))),expression:"(!query.isToday || !hideDepartured || !isDeparture( train.StopTimes[0].DepartureTime ))"}],key:train.TrainInfo.TrainNo,attrs:{"train":train,"fares":_vm.fares},nativeOn:{"click":function($event){_vm.toTrainDetail(train)}}})})],2)]):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',{staticClass:"one wide center aligned"},[_c('h4',{staticClass:"ui header"},[_vm._v("\n                經由\n                "),_c('div',{staticClass:"sub header"},[_vm._v("Via")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_vm._v("\n                  開車時間\n                  "),_c('div',{staticClass:"sub header"},[_vm._v("Departure")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_vm._v("\n                  行車時間\n                  "),_c('div',{staticClass:"sub header"},[_vm._v("Travel Time")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_vm._v("\n                  抵達時間\n                  "),_c('div',{staticClass:"sub header"},[_vm._v("Arrival")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',{staticClass:"five wide"},[_c('h4',{staticClass:"ui header"},[_vm._v("\n                其他\n                "),_c('div',{staticClass:"sub header"},[_vm._v("Information")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',{staticClass:"ui header"},[_vm._v("\n                誤點\n                "),_c('div',{staticClass:"sub header"},[_vm._v("Delay")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',{staticClass:"one wide"},[_c('h4',{staticClass:"ui header"},[_vm._v("\n                票價\n                "),_c('div',{staticClass:"sub header"},[_vm._v("Fare")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_vm._v("\n              開車時間\n              "),_c('div',{staticClass:"sub header"},[_vm._v("Departure")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_vm._v("\n              行車時間\n              "),_c('div',{staticClass:"sub header"},[_vm._v("Travel Time")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_vm._v("\n              抵達時間\n              "),_c('div',{staticClass:"sub header"},[_vm._v("Arrival")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FVg3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TrainItem_vue__ = __webpack_require__("gvMo");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f29cd1f8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TrainItem_vue__ = __webpack_require__("rlqe");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TrainItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f29cd1f8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TrainItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "GnjR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Train_vue__ = __webpack_require__("It6M");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_267aec22_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Train_vue__ = __webpack_require__("FElo");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Train_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_267aec22_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Train_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "Gvql":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7302281e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchTips_vue__ = __webpack_require__("Bjt9");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7302281e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchTips_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "It6M":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      train: null,
      query: null
    };
  },

  computed: {
    status: function status() {
      if (this.query === null) {
        return "loading";
      }

      if (this.query) {
        return !_.isEmpty(this.train) && this.train.StopTimes.length > 0;
      }

      return false;
    }
  },
  methods: {
    getTimetable: function getTimetable() {
      var _this = this;

      this.searchTimetableByTrainNo(this.$route.params.train, this.$route.params.date).then(function (response) {
        _this.query = response.data.query;
        _this.train = response.data.payload || {};
      }, function (error) {
        // handle
      });
    }
  },
  mounted: function mounted() {
    this.getTimetable();
  }
});

/***/ }),

/***/ "JMZ3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui grid stackable container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"ui sixteen wide column"},[_c('div',{staticClass:"ui form"},[_c('div',{staticClass:"field",class:{ error: _vm.isEmptyResult }},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.input.keyword),expression:"input.keyword",modifiers:{"trim":true}}],attrs:{"type":"text","placeholder":"車站名稱、代碼","autofocus":""},domProps:{"value":(_vm.input.keyword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.input, "keyword", $event.target.value.trim())},"blur":function($event){_vm.$forceUpdate()}}})])])])]),_vm._v(" "),(_vm._.isEmpty(_vm.stations))?_c('Loading'):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"ui sixteen wide column"},[(_vm.isEmptyResult)?_c('div',{staticClass:"ui orange message"},[_vm._v("查無此車站，請重新輸入車站名稱或車站代碼查詢")]):_c('table',{staticClass:"ui definition table"},[_vm._m(0),_vm._v(" "),_c('tbody',_vm._l((_vm.stationsRendered),function(station){return _c('router-link',{key:station.$id,staticClass:"pointer",attrs:{"tag":"tr","to":{
              name: 'Station.view',
              params: {
                station: station.StationID,
                date: _vm.moment().format('YYYY-MM-DD')
              }
            }}},[_c('td',[_c('h4',{staticClass:"ui header"},[_c('i',{staticClass:"icon grey"},[_vm._v(_vm._s(_vm.stationClass(station.StationClass)))]),_vm._v(" "),_c('div',{staticClass:"content pointer"},[_vm._v("\n                  "+_vm._s(station.StationName.Zh_tw)+"\n                  "),_c('div',{staticClass:"sub header"},[_vm._v(_vm._s(station.StationName.En))])])])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(station.StationID))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(station.StationPhone))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(station.StationAddress))])])}))])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"two wide"}),_vm._v(" "),_c('th',{staticClass:"one wide"},[_c('h4',{staticClass:"ui header"},[_vm._v("\n                編號\n                "),_c('div',{staticClass:"sub header"},[_vm._v("Code")])])]),_vm._v(" "),_c('th',{staticClass:"three wide"},[_c('h4',{staticClass:"ui header"},[_vm._v("\n                電話\n                "),_c('div',{staticClass:"sub header"},[_vm._v("Telephone")])])]),_vm._v(" "),_c('th',{staticClass:"five wide"},[_c('h4',{staticClass:"ui header"},[_vm._v("\n                地址\n                "),_c('div',{staticClass:"sub header"},[_vm._v("Address")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KlNx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_History_vue__ = __webpack_require__("Bzo/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dfceba82_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_History_vue__ = __webpack_require__("dk8/");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_History_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dfceba82_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_History_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Kw/6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Search_vue__ = __webpack_require__("hV6e");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03f17101_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Search_vue__ = __webpack_require__("FVEL");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Search_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03f17101_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Search_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "LntH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TrainItem_vue__ = __webpack_require__("9pRa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TrainItemMobile_vue__ = __webpack_require__("57PL");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      query: null,
      station: null,
      trains: [],

      trainInfo: false,
      delayInfo: [],
      direction: undefined,
      hideDepartured: true,
      status: true
    };
  },

  methods: {
    /**
     * 導航到列車詳細資訊
     */
    toTrainDetail: function toTrainDetail(train) {
      this.$router.push({
        name: "Timetable.train",
        params: {
          train: train.TrainInfo.TrainNo,
          date: this.query.date
        }
      });
    },
    /**
     * Page initialization
     */
    init: function init() {
      var _this = this;

      this.getStationDetail(this.$route.params.station, this.$route.params.date).then(function (response) {
        _this.query = response.data.query;
        _this.station = response.data.payload;

        /** handle 找不到此站 */
        // this.$router.push('/station');

        _this.getTimetableByStationNo(_this.$route.params.station, _this.$route.params.date).then(function (response) {
          _this.trains = response.data.payload;
          // this.status = true;
        }, function (error) {
          // this.status = false;
        });
      }, function (error) {});
    },
    /**
     * Switch direction
     */
    directionSwitch: function directionSwitch(d) {
      this.direction = d == this.direction ? undefined : d;
    },
    /**
     * Back today
     */
    backToday: function backToday() {
      this.period = this.searchDate();
      this.status = "loading";
      this.trainInfo = false;
      this.init();
      this.$router.replace({
        params: {
          date: this.period.date
        }
      });
    }
  },
  computed: {
    trainsRendered: function trainsRendered() {
      var filtered = _.isUndefined(this.direction) ? this.trains : _.filter(this.trains, {
        TrainInfo: { Direction: this.direction }
      });

      return _.orderBy(filtered, "TrainInfo.DepartureTime", "asc");
    }
  },
  components: {
    TrainItem: __WEBPACK_IMPORTED_MODULE_0__TrainItem_vue__["a" /* default */],
    TrainItemMobile: __WEBPACK_IMPORTED_MODULE_1__TrainItemMobile_vue__["a" /* default */]
  },
  mounted: function mounted() {
    this.init();
  }
});

/***/ }),

/***/ "M35L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["train"]
});

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e1468bb6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("BCH6");
function injectStyle (ssrContext) {
  __webpack_require__("ue78")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e1468bb6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_fuse_js__ = __webpack_require__("BDm9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_fuse_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_fuse_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_ls__ = __webpack_require__("yXtV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_ls___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_ls__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_lodashMethods__ = __webpack_require__("0H84");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.









/**
 * Style Files
 */
__webpack_require__("crOU");

/**
 * Extra Custom Scripts
 */
__webpack_require__("OF+h");

/**
 * Mount components
 */
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('Loading', __webpack_require__("wRmV").default);

/**
 * Moment.js
 */
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.moment = __WEBPACK_IMPORTED_MODULE_4_moment___default.a;
/**
 * Lodash
 */
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype._ = __webpack_require__("M4fF");

__WEBPACK_IMPORTED_MODULE_4_moment___default.a.locale('zh_tw');

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

window.Fuse = __WEBPACK_IMPORTED_MODULE_5_fuse_js___default.a;
window.axios = __WEBPACK_IMPORTED_MODULE_3_axios___default.a;

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue_ls___default.a);

_.mixin(__WEBPACK_IMPORTED_MODULE_7__helpers_lodashMethods__["a" /* default */]);

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: {
    App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */]
  }
});

/***/ }),

/***/ "OF+h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");


__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].mixin({
  data: function data() {
    return {
      /**
       * Get date from Route parameters
       */
      // TODO: remove this
      period: {}
      // period: this.searchDate(this.$router.params.date || this.$ls.get('period.date'))
    };
  },

  methods: __webpack_require__("tF+R").default,
  filters: __webpack_require__("aGO7").default,
  mounted: function mounted() {
    /**
     * Control user reload & clear local storage manually
     */
    var ver = '201807111859';
    var refresh = this.$ls.get('app.refresh', false);

    if (!refresh || refresh !== ver) {
      this.$ls.clear();
      this.$ls.set('app.refresh', ver);
      location.reload();
    }
  }
});

/***/ }),

/***/ "THYD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui secondary segment"},[_c('div',{staticClass:"ui grid stackable"},[_c('div',{staticClass:"eleven wide column message"},[_c('h3',{staticClass:"ui header"},[_vm._v("\n        "+_vm._s(_vm.query.dateHumanize)+"\n        "),_c('div',{staticClass:"ui sub header"},[_c('router-link',{attrs:{"to":{
                  name: 'Station.view',
                  params: {
                    station: _vm.query.origin.code,
                    date: _vm.query.date
                  }
                }}},[_vm._v(_vm._s(_vm.query.origin.name))]),_vm._v(" 到\n          "),_c('router-link',{attrs:{"to":{
                  name: 'Station.view',
                  params: {
                    station: _vm.query.destination.code,
                    date: _vm.query.date
                  }
                }}},[_vm._v(_vm._s(_vm.query.destination.name))]),_vm._v(" 的\n          "),_c('span',{staticClass:"ui pointer",on:{"click":function($event){_vm.$emit('trainClassMapCrossClicked')}}},[_vm._v("\n            "+_vm._s(_vm.trainClassMap.nameShownAs || '所有列車')+"\n            "),(_vm._.isNotEmpty(_vm.trainClassMap))?_c('i',{staticClass:"delete red icon"}):_vm._e()])],1)]),_vm._v(" "),_c('p',[_vm._v("\n        共有 "+_vm._s(_vm.trainsResponseCount)+" 班列車\n        "),(_vm._.isNotEmpty(_vm.trainClassMap))?_c('span',[_vm._v("，顯示 "+_vm._s(_vm.trains.length)+" 個結果")]):_vm._e()])]),_vm._v(" "),(_vm.fares)?_c('div',{staticClass:"ui five wide column"},[_c('table',{staticClass:"ui very compact unstackable very basic table"},[_c('thead',[_c('tr',[_c('th',{staticClass:"three wide"}),_vm._v(" "),_c('th',{staticClass:"three wide"},[_c('h5',{staticClass:"ui red header pointer",on:{"click":function($event){_vm.$emit('trainTypeClicked', 'tc')}}},[_vm._v("\n                自強\n                "),_c('div',{staticClass:"sub header"},[_vm._v("T.C.")])])]),_vm._v(" "),_c('th',{staticClass:"three wide"},[_c('h5',{staticClass:"ui orange header pointer",on:{"click":function($event){_vm.$emit('trainTypeClicked', 'ck')}}},[_vm._v("\n                莒光\n                "),_c('div',{staticClass:"sub header"},[_vm._v("C.K.")])])]),_vm._v(" "),_c('th',{staticClass:"three wide"},[_c('h5',{staticClass:"ui header pointer",on:{"click":function($event){_vm.$emit('trainTypeClicked', 'lt')}}},[_vm._v("\n                區間\n                "),_c('div',{staticClass:"sub header"},[_vm._v("L.T.")])])])])]),_vm._v(" "),_c('tbody',[_c('tr',[_c('td',[_vm._v("票價")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.fares['3'].price))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.fares['4'].price))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.fares['6'].price))])])])])]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "TaWI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hello"},[_c('h1',[_vm._v(_vm._s(_vm.msg))]),_vm._v(" "),_c('h2',[_vm._v("Essential Links")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('h2',[_vm._v("Ecosystem")]),_vm._v(" "),_vm._m(1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_c('a',{attrs:{"href":"https://vuejs.org","target":"_blank"}},[_vm._v("Core Docs")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"https://forum.vuejs.org","target":"_blank"}},[_vm._v("Forum")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"https://chat.vuejs.org","target":"_blank"}},[_vm._v("Community Chat")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"https://twitter.com/vuejs","target":"_blank"}},[_vm._v("Twitter")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"http://vuejs-templates.github.io/webpack/","target":"_blank"}},[_vm._v("Docs for This Template")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_c('a',{attrs:{"href":"http://router.vuejs.org/","target":"_blank"}},[_vm._v("vue-router")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"http://vuex.vuejs.org/","target":"_blank"}},[_vm._v("vuex")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"http://vue-loader.vuejs.org/","target":"_blank"}},[_vm._v("vue-loader")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"https://github.com/vuejs/awesome-vue","target":"_blank"}},[_vm._v("awesome-vue")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UGwd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TrainItemMobile_vue__ = __webpack_require__("WZSG");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5bf22166_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TrainItemMobile_vue__ = __webpack_require__("1ubc");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TrainItemMobile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5bf22166_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TrainItemMobile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "WPd6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui inverted dimmer active"},[_c('div',{staticClass:"ui loader"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "WZSG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["train", "fares"],
  data: function data() {
    return {};
  },

  methods: {
    /**
     * 取得票價
     */
    getFare: function getFare(code) {
      return this.fares[code].price;
    }
  }
});

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Hello__ = __webpack_require__("qSdX");




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  linkActiveClass: 'active',
  base: '/trainfo/',
  routes: [{
    path: '/',
    redirect: '/timetable'
  }, {
    path: '/timetable',
    name: 'Timetable',
    component: __webpack_require__("Kw/6").default
  }, {
    path: '/timetable/:train/:date?',
    name: 'Timetable.train',
    component: __webpack_require__("GnjR").default
  }, {
    path: '/station',
    name: 'Station',
    component: __webpack_require__("r91A").default
  }, {
    path: '/station/:station/:date?',
    name: 'Station.view',
    component: __webpack_require__("+OcR").default
  }, {
    path: '/about',
    name: 'About',
    component: __webpack_require__("q901").default
  }]
}));

/***/ }),

/***/ "ZX8f":
/***/ (function(module, exports) {

module.exports = {"tc":{"nameShownAs":"自強號","includes":["1","2","3"]},"ck":{"nameShownAs":"莒光號","includes":["4"]},"lt":{"nameShownAs":"區間車","includes":["5","6","7","10"]},"trk":{"nameShownAs":"太魯閣號","includes":["1"]},"pym":{"nameShownAs":"普悠瑪號","includes":["2"]},"tilting":{"nameShownAs":"傾斜式列車","includes":["1","2"]},"reserved":{"nameShownAs":"對號列車","includes":["1","2","3","4"]}}

/***/ }),

/***/ "aGO7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__static_trainclasses_json__ = __webpack_require__("+2Sp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__static_trainclasses_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__static_trainclasses_json__);



/* harmony default export */ __webpack_exports__["default"] = ({

  /**
   * Formatting note. Strip `每日行駛。` from note.
   */
  noteFormat: function noteFormat() {
    var n = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    return n.replace('每日行駛。', '').replace(/柴聯自強號(，|。)/ig, '');
  }

});

/***/ }),

/***/ "abwL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      input: {
        keyword: ""
      },
      stations: []
    };
  },

  methods: {
    stationClass: function stationClass(givenLevel) {
      var levels = {
        "0": "特",
        "4": "簡",
        "5": "招"
      };

      return _.get(levels, givenLevel, givenLevel);
    }
  },
  computed: {
    isEmptyResult: function isEmptyResult() {
      return !_.isEmpty(this.stations) && _.isEmpty(this.stationsRendered);
    },
    stationsRendered: function stationsRendered() {
      if (_.isEmpty(this.keyword)) {
        return _.orderBy(this.stations, ["StationID"], "asc");
      }

      return new Fuse(this.stations, {
        threshold: 0.2,
        keys: ["StationID", "StationName.Zh_tw", "StationName.En", "StationAddress", "StationPhone"]
      }).search(this.keyword);
    },
    keyword: function keyword() {
      return this.taiTransform(this.input.keyword);
    }
  },
  mounted: function mounted() {
    var _this = this;

    var stations = this.$ls.get("stations");

    if (!_.isNull(stations)) {
      return this.stations = stations;
    }

    this.getStations().then(function (response) {
      _this.stations = response.data.payload;

      var expireMs = _this.moment().add(6, "hours").diff();

      _this.$ls.set("stations", _this.stations, expireMs);
    }, function (error) {
      // this.status = false;
    });
  }
});

/***/ }),

/***/ "crOU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dR3Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["train"],
  methods: {
    getName: function getName(train) {
      var name = _.get(train, "TrainInfo.TrainTypeName.Zh_tw", "");

      if ("" === name) {
        return "列車";
      }

      return name;
    }
  }
});

/***/ }),

/***/ "dk8/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"field"},_vm._l((_vm.history),function(keyword){return _c('div',{key:keyword,staticClass:"ui label pointer",on:{"click":function($event){_vm.$emit('historyLabelClicked', keyword)}}},[_vm._v(_vm._s(keyword))])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "fUqv":
/***/ (function(module, exports) {

module.exports = [{"Station_Code_4":6103,"Station_Name":"海科館","Station_EName":"NMMST","Station_Code_3":291,"WebsiteName":"海科館站","EnglishName":"NMMST","ChineseAddress":"無","EnglishAddress":"none","Telephone":"02-24972033","gps":"25.137706, 121.800023"},{"Station_Code_4":1810,"Station_Name":"福隆","Station_EName":"Fulong","Station_Code_3":83,"WebsiteName":"福隆站","EnglishName":"Fulong","ChineseAddress":"新北市貢寮區福隆里福隆街2號","EnglishAddress":"No.2, Fulong St., Gongliao Dist., New Taipei City , Taiwan (R.O.C.)","Telephone":"02-24991800","gps":"25.015893,121.944659"},{"Station_Code_4":1809,"Station_Name":"貢寮","Station_EName":"Gongliao","Station_Code_3":84,"WebsiteName":"貢寮站","EnglishName":"Gongliao","ChineseAddress":"新北市貢寮區貢寮里朝陽街33號","EnglishAddress":"No.33, Chaoyang St., Gongliao Dist., New Taipei City , Taiwan (R.O.C.)","Telephone":"02-24941500","gps":"25.022044,121.908703"},{"Station_Code_4":1808,"Station_Name":"雙溪","Station_EName":"Shuangxi","Station_Code_3":85,"WebsiteName":"雙溪站","EnglishName":"Shuangxi","ChineseAddress":"新北市雙溪區新基里朝陽街1號","EnglishAddress":"No.1, Chaoyang St., Shuangxi Dist., New Taipei City , Taiwan (R.O.C.)","Telephone":"02-24991800","gps":"25.038544,121.866548"},{"Station_Code_4":1807,"Station_Name":"牡丹","Station_EName":"Mudan","Station_Code_3":86,"WebsiteName":"牡丹站","EnglishName":"Mudan","ChineseAddress":"新北市雙溪區牡丹路159號","EnglishAddress":"No.159, Mudan Rd., Shuangxi Dist., New Taipei City , Taiwan (R.O.C.)","Telephone":"02-24932980","gps":"25.058738,121.851977"},{"Station_Code_4":1806,"Station_Name":"三貂嶺","Station_EName":"Sandiaoling","Station_Code_3":87,"WebsiteName":"三貂嶺站","EnglishName":"Sandiaoling","ChineseAddress":"新北市瑞芳區碩仁里魚寮路1號","EnglishAddress":"No.1, Yuliao Rd., Ruifang Dist., New Taipei City , Taiwan (R.O.C.)","Telephone":"02-24977896","gps":"25.065544,121.822559"},{"Station_Code_4":1805,"Station_Name":"侯硐","Station_EName":"Houtong","Station_Code_3":88,"WebsiteName":"侯硐站","EnglishName":"Houtong","ChineseAddress":"新北市瑞芳區光復里柴寮路70號","EnglishAddress":"No.70, Chailiao Rd., Ruifang Dist., New Taipei City , Taiwan (R.O.C.)","Telephone":"02-24977747","gps":"25.087009,121.827424"},{"Station_Code_4":1804,"Station_Name":"瑞芳","Station_EName":"Ruifang","Station_Code_3":89,"WebsiteName":"瑞芳站","EnglishName":"Ruifang","ChineseAddress":"新北市瑞芳區龍潭里明燈路3段82號","EnglishAddress":"No.82, Sec. 3, Mingdeng Rd., Ruifang Dist., New Taipei City , Taiwan (R.O.C.)","Telephone":"02-24972033","gps":"25.108928,121.806149"},{"Station_Code_4":1803,"Station_Name":"四腳亭","Station_EName":"Sijiaoting","Station_Code_3":90,"WebsiteName":"四腳亭站","EnglishName":"Sijiaoting","ChineseAddress":"新北市瑞芳區吉慶里中央路65號","EnglishAddress":"No.65, Zhongyang Rd., Ruifang Dist., New Taipei City , Taiwan (R.O.C.)","Telephone":"02-24579346","gps":"25.102751,121.761887"},{"Station_Code_4":1802,"Station_Name":"暖暖","Station_EName":"Nuannuan","Station_Code_3":91,"WebsiteName":"暖暖站","EnglishName":"Nuannuan","ChineseAddress":"基隆市暖暖街51號","EnglishAddress":"No.51 , Nuannuan Rd. , Nuannuan Dist., Keelung City, Taiwan (R.O.C.)","Telephone":"02-24972033","gps":"25.102282,121.740329"},{"Station_Code_4":1001,"Station_Name":"基隆","Station_EName":"Keelung","Station_Code_3":92,"WebsiteName":"基隆站","EnglishName":"Keelung","ChineseAddress":"基隆市仁愛區文昌里港西街5號","EnglishAddress":"No.5, Gangxi St., Ren’ai Dist., Keelung City , Taiwan (R.O.C.)","Telephone":"02-24263743","gps":"25.131598, 121.738366"},{"Station_Code_4":1029,"Station_Name":"三坑","Station_EName":"Sankeng","Station_Code_3":224,"WebsiteName":"三坑站","EnglishName":"Sankeng","ChineseAddress":"基隆市仁愛區龍安街206號","EnglishAddress":"No.206, Long’an St., Ren’ai Dist., Keelung City , Taiwan (R.O.C.)","Telephone":"02-24230289","gps":"25.123081,121.742009"},{"Station_Code_4":1002,"Station_Name":"八堵","Station_EName":"Badu","Station_Code_3":93,"WebsiteName":"八堵站","EnglishName":"Badu","ChineseAddress":"基隆市暖暖區八南里八堵路142號","EnglishAddress":"No.142, Badu Rd., Nuannuan Dist., Keelung City , Taiwan (R.O.C.)","Telephone":"02-24560841","gps":"25.108392,121.729049"},{"Station_Code_4":1003,"Station_Name":"七堵","Station_EName":"Qidu","Station_Code_3":94,"WebsiteName":"七堵站","EnglishName":"Qidu","ChineseAddress":"基隆市七堵區長興里東新街2號之1","EnglishAddress":"No.2-1, Dongxin St., Qidu Dist., Keelung City , Taiwan (R.O.C.)","Telephone":"02-24553426","gps":"25.0933592,121.713868"},{"Station_Code_4":1015,"Station_Name":"桃園","Station_EName":"Taoyuan","Station_Code_3":106,"WebsiteName":"桃園站","EnglishName":"Taoyuan","ChineseAddress":"桃園縣桃園市武陵里中正路1號","EnglishAddress":"No.1, Zhongzheng Rd., Taoyuan Dist., Taoyuan City , Taiwan (R.O.C.)","Telephone":"03-3323304","gps":"24.989209,121.313499"},{"Station_Code_4":1016,"Station_Name":"內壢","Station_EName":"Neili","Station_Code_3":107,"WebsiteName":"內壢站","EnglishName":"Neili","ChineseAddress":"桃園縣中壢市中原里中華路1段267號","EnglishAddress":"No.267, Sec. 1, Zhonghua Rd., Zhongli Dist., Taoyuan City , Taiwan (R.O.C.)","Telephone":"03-4559725","gps":"24.972797,121.258258"},{"Station_Code_4":1017,"Station_Name":"中壢","Station_EName":"Zhongli","Station_Code_3":108,"WebsiteName":"中壢站","EnglishName":"Zhongli","ChineseAddress":"桃園縣中壢市石頭里中和路139號","EnglishAddress":"No.139, Zhonghe Rd., Zhongli Dist., Taoyuan City , Taiwan (R.O.C.)","Telephone":"03-4223235","gps":"24.953666,121.225798"},{"Station_Code_4":1018,"Station_Name":"埔心","Station_EName":"Puxin","Station_Code_3":109,"WebsiteName":"埔心站","EnglishName":"Puxin","ChineseAddress":"桃園縣楊梅市埔心里永美路208之1號","EnglishAddress":"No.208-1, Yongmei Rd., Yangmei Dist., Taoyuan City , Taiwan (R.O.C.)","Telephone":"03-4827100","gps":"24.919951,121.183827"},{"Station_Code_4":1019,"Station_Name":"楊梅","Station_EName":"Yangmei","Station_Code_3":110,"WebsiteName":"楊梅站","EnglishName":"Yangmei","ChineseAddress":"桃園縣楊梅市楊梅里大成路256號","EnglishAddress":"No.256, Dacheng Rd., Yangmei Dist., Taoyuan City , Taiwan (R.O.C.)","Telephone":"03-4782893","gps":"24.914346,121.146405"},{"Station_Code_4":1020,"Station_Name":"富岡","Station_EName":"Fugang","Station_Code_3":111,"WebsiteName":"富岡站","EnglishName":"Fugang","ChineseAddress":"桃園縣楊梅市富岡里成功路37號","EnglishAddress":"No.37, Chenggong Rd., Yangmei Dist., Taoyuan City , Taiwan (R.O.C.)","Telephone":"03-4723754","gps":"24.934273,121.083019"},{"Station_Code_4":1033,"Station_Name":"北湖","Station_EName":"Beihu(China University of Technology)","Station_Code_3":271,"WebsiteName":"北湖站","EnglishName":"Beihu(China University of Technology)","ChineseAddress":"新竹縣湖口鄉東興村北湖路1號","EnglishAddress":"No.1 , Beihu Rd. , Hukou Township, Hsinchu County , Taiwan (R.O.C.)","Telephone":"03-5993850","gps":"24.922207,121.055671"},{"Station_Code_4":1021,"Station_Name":"湖口","Station_EName":"Hukou","Station_Code_3":112,"WebsiteName":"湖口站","EnglishName":"Hukou","ChineseAddress":"新竹縣湖口鄉仁勢村中山路2段121號","EnglishAddress":"No.121, Sec. 2, Zhongshan Rd., Hukou Township, Hsinchu County , Taiwan (R.O.C.)","Telephone":"03-5992192","gps":"24.903029,121.044009"},{"Station_Code_4":1022,"Station_Name":"新豐","Station_EName":"Xinfeng","Station_Code_3":113,"WebsiteName":"新豐站","EnglishName":"Xinfeng","ChineseAddress":"新竹縣新豐鄉員山村新興路202號","EnglishAddress":"No.202, Xinxing Rd., Xinfeng Township, Hsinchu County , Taiwan (R.O.C.)","Telephone":"03-5596314","gps":"24.869228,120.99634"},{"Station_Code_4":1023,"Station_Name":"竹北","Station_EName":"Zhubei","Station_Code_3":114,"WebsiteName":"竹北站","EnglishName":"Zhubei","ChineseAddress":"新竹縣竹北市福德里和平街59號","EnglishAddress":"No.59, Heping St., Zhubei City, Hsinchu County , Taiwan (R.O.C.)","Telephone":"03-5552024","gps":"24.839283,121.009376"},{"Station_Code_4":1024,"Station_Name":"北新竹","Station_EName":"North Hsinchu","Station_Code_3":237,"WebsiteName":"北新竹站","EnglishName":"North Hsinchu","ChineseAddress":"新竹市中華路1段291之2號","EnglishAddress":"No.291-2, Sec. 1, Zhonghua Rd., East Dist., Hsinchu City , Taiwan (R.O.C.)","Telephone":"03-5237441","gps":"24.808746,120.98367"},{"Station_Code_4":1025,"Station_Name":"新竹","Station_EName":"Hsinchu","Station_Code_3":115,"WebsiteName":"新竹站","EnglishName":"Hsinchu","ChineseAddress":"新竹市榮光里中華路2段445號","EnglishAddress":"No.445, Sec. 2, Zhonghua Rd., East Dist., Hsinchu City , Taiwan (R.O.C.)","Telephone":"03-5237441","gps":"24.801637,120.971627"},{"Station_Code_4":1027,"Station_Name":"崎頂","Station_EName":"Qiding","Station_Code_3":117,"WebsiteName":"崎頂站","EnglishName":"Qiding","ChineseAddress":"苗栗縣竹南鎮崎頂里北戶55號","EnglishAddress":"No.55, Beihu , Zhunan Township, Miaoli County , Taiwan (R.O.C.)","Telephone":"037-472030","gps":"24.722782,120.87179"},{"Station_Code_4":1028,"Station_Name":"竹南","Station_EName":"Zhunan","Station_Code_3":118,"WebsiteName":"竹南站","EnglishName":"Zhunan","ChineseAddress":"苗栗縣竹南鎮中山路166號","EnglishAddress":"No.166, Zhongshan Rd., Zhunan Township, Miaoli County , Taiwan (R.O.C.)","Telephone":"037-472030","gps":"24.686562,120.880888"},{"Station_Code_4":1030,"Station_Name":"百福","Station_EName":"Baifu","Station_Code_3":261,"WebsiteName":"百福站","EnglishName":"Baifu","ChineseAddress":"基隆市明德三路1-1號","EnglishAddress":"No.1-1, Mingde 3rd Rd., Qidu Dist., Keelung City , Taiwan (R.O.C.)","Telephone":"02-24528372","gps":"25.077927,121.693869"},{"Station_Code_4":1004,"Station_Name":"五堵","Station_EName":"Wudu","Station_Code_3":95,"WebsiteName":"五堵站","EnglishName":"Wudu","ChineseAddress":"新北市汐止區長安里長安路17號","EnglishAddress":"No.17, Chang’an Rd., Xizhi Dist., New Taipei City , Taiwan (R.O.C.)","Telephone":"02-86476200","gps":"25.078,121.667701"},{"Station_Code_4":1005,"Station_Name":"汐止","Station_EName":"Xizhi","Station_Code_3":96,"WebsiteName":"汐止站","EnglishName":"Xizhi","ChineseAddress":"新北市汐止區信望里信義路1號","EnglishAddress":"No.1, Xinyi Rd., Xizhi Dist., New Taipei City , Taiwan (R.O.C.)","Telephone":"02-26415096","gps":"25.068224,121.661757"},{"Station_Code_4":1031,"Station_Name":"汐科","Station_EName":"Xike","Station_Code_3":262,"WebsiteName":"汐科站","EnglishName":"Xike","ChineseAddress":"新北市汐止區大同路2段182號","EnglishAddress":"No.182, Sec. 2, Datong Rd., Xizhi Dist., New Taipei City , Taiwan (R.O.C.)","Telephone":"02-23815226#8730","gps":"25.062626,121.646584"},{"Station_Code_4":1035,"Station_Name":"三姓橋","Station_EName":"Sanxingqiao","Station_Code_3":273,"WebsiteName":"三姓橋站","EnglishName":"Sanxingqiao","ChineseAddress":"新竹市香山區元培街32巷30號","EnglishAddress":"No.30, Ln. 32, Yuanpei St., Xiangshan Dist., Hsinchu City 300, Taiwan (R.O.C.)","Telephone":"03-5962042","gps":"24.787550, 120.928937"},{"Station_Code_4":1102,"Station_Name":"談文","Station_EName":"Tanwen","Station_Code_3":119,"WebsiteName":"談文站","EnglishName":"Tanwen","ChineseAddress":"苗栗縣造橋鄉談文村仁愛路29號","EnglishAddress":"No.29, Ren’ai Rd., Zaoqiao Township, Miaoli County , Taiwan (R.O.C.)","Telephone":"037-472030","gps":"24.656414, 120.858241"},{"Station_Code_4":1104,"Station_Name":"大山","Station_EName":"Dashan","Station_Code_3":120,"WebsiteName":"大山站","EnglishName":"Dashan","ChineseAddress":"苗栗縣後龍鎮大山里明山路180號","EnglishAddress":"No.180, Mingshan Rd., Houlong Township, Miaoli County , Taiwan (R.O.C.)","Telephone":"037-728616","gps":"24.645645,120.803778"},{"Station_Code_4":1105,"Station_Name":"後龍","Station_EName":"Houlong","Station_Code_3":121,"WebsiteName":"後龍站","EnglishName":"Houlong","ChineseAddress":"苗栗縣後龍鎮南龍里車站街127號","EnglishAddress":"No.127, Chezhan St., Houlong Township, Miaoli County , Taiwan (R.O.C.)","Telephone":"037-728616","gps":"24.616212,120.787307"},{"Station_Code_4":1106,"Station_Name":"龍港","Station_EName":"Longgang","Station_Code_3":122,"WebsiteName":"龍港站","EnglishName":"Longgang","ChineseAddress":"苗栗縣後龍鎮龍京里7鄰公司寮85號","EnglishAddress":"No.85, Gongsiliao, Houlong Township, Miaoli County , Taiwan (R.O.C.)","Telephone":"037-728616","gps":"24.611683,120.758142"},{"Station_Code_4":1107,"Station_Name":"白沙屯","Station_EName":"Baishatun","Station_Code_3":123,"WebsiteName":"白沙屯站","EnglishName":"Baishatun","ChineseAddress":"苗栗縣通霄鎮白西里131號","EnglishAddress":"No.131, Baixi, Tongxiao Township, Miaoli County , Taiwan (R.O.C.)","Telephone":"037-793066","gps":"24.564797,120.708198"},{"Station_Code_4":1108,"Station_Name":"新埔","Station_EName":"Xinpu","Station_Code_3":124,"WebsiteName":"新埔站","EnglishName":"Xinpu","ChineseAddress":"苗栗縣通霄鎮新埔里8鄰57號","EnglishAddress":"No.57, Xinpu, Tongxiao Township, Miaoli County , Taiwan (R.O.C.)","Telephone":"037-793066","gps":"24.540180,120.695179"},{"Station_Code_4":1109,"Station_Name":"通霄","Station_EName":"Tongxiao","Station_Code_3":125,"WebsiteName":"通霄站","EnglishName":"Tongxiao","ChineseAddress":"苗栗縣通霄鎮通西里中山路109號","EnglishAddress":"No.109, Zhongshan Rd., Tongxi Vil., Tongxiao Township, Miaoli County , Taiwan (R.O.C.)","Telephone":"037-758300","gps":"24.491403,120.678425"},{"Station_Code_4":1110,"Station_Name":"苑裡","Station_EName":"Yuanli","Station_Code_3":126,"WebsiteName":"苑裡站","EnglishName":"Yuanli","ChineseAddress":"苗栗縣苑裡鎮中山路165號","EnglishAddress":"No.165, Zhongshan Rd., Yuanli Township, Miaoli County , Taiwan (R.O.C.)","Telephone":"037-851013","gps":"24.443426,120.651494"},{"Station_Code_4":1111,"Station_Name":"日南","Station_EName":"Rinan","Station_Code_3":127,"WebsiteName":"日南站","EnglishName":"Rinan","ChineseAddress":"臺中市大甲區孟春里中山路2段140巷8號","EnglishAddress":"No.8, Ln. 140, Sec. 2, Zhongshan Rd., Dajia Dist., Taichung City , Taiwan (R.O.C.)","Telephone":"04-26816113","gps":"24.378066,120.654119"},{"Station_Code_4":1112,"Station_Name":"大甲","Station_EName":"Dajia","Station_Code_3":128,"WebsiteName":"大甲站","EnglishName":"Dajia","ChineseAddress":"臺中市大甲區中山路1段828號","EnglishAddress":"No.828, Sec. 1, Zhongshan Rd., Dajia Dist., Taichung City , Taiwan (R.O.C.)","Telephone":"04-26872022","gps":"24.344430,120.627017"},{"Station_Code_4":1113,"Station_Name":"臺中港","Station_EName":"Taichung Port","Station_Code_3":129,"WebsiteName":"臺中港站","EnglishName":"Taichung Port","ChineseAddress":"臺中市清水區甲南路2號","EnglishAddress":"No.2, Jianan Rd., Qingshui Dist., Taichung City , Taiwan (R.O.C.)","Telephone":"04-26225374","gps":"24.304366,120.602297"},{"Station_Code_4":1114,"Station_Name":"清水","Station_EName":"Qingshui","Station_Code_3":130,"WebsiteName":"清水站","EnglishName":"Qingshui","ChineseAddress":"臺中市清水區南社里中正街115號","EnglishAddress":"No.115, Zhongzheng St., Qingshui Dist., Taichung City , Taiwan (R.O.C.)","Telephone":"04-26222021","gps":"24.263624,120.569178"},{"Station_Code_4":1115,"Station_Name":"沙鹿","Station_EName":"Shalu","Station_Code_3":131,"WebsiteName":"沙鹿站","EnglishName":"Shalu","ChineseAddress":"臺中市沙鹿區中正街94號","EnglishAddress":"No.94, Zhongzheng St., Shalu Dist., Taichung City , Taiwan (R.O.C.)","Telephone":"04-26625057","gps":"24.237044,120.557627"},{"Station_Code_4":1116,"Station_Name":"龍井","Station_EName":"Longjing","Station_Code_3":132,"WebsiteName":"龍井站","EnglishName":"Longjing","ChineseAddress":"臺中市龍井區龍新路1號","EnglishAddress":"No.1, Longxin Rd., Longjing Dist., Taichung City , Taiwan (R.O.C.)","Telephone":"04-26355578","gps":"24.197444,120.543371"},{"Station_Code_4":1117,"Station_Name":"大肚","Station_EName":"Dadu","Station_Code_3":133,"WebsiteName":"大肚站","EnglishName":"Dadu","ChineseAddress":"臺中市大肚區平和街121號","EnglishAddress":"No.121, Pinghe St., Dadu Dist., Taichung City , Taiwan (R.O.C.)","Telephone":"04-26992523","gps":"24.154024,120.542536"},{"Station_Code_4":1118,"Station_Name":"追分","Station_EName":"Zhuifen","Station_Code_3":134,"WebsiteName":"追分站","EnglishName":"Zhuifen","ChineseAddress":"臺中市大肚區王田里追分街13號","EnglishAddress":"No.13, Zhuifen St., Dadu Dist., Taichung City , Taiwan (R.O.C.)","Telephone":"04-26933106","gps":"24.120613,120.570158"},{"Station_Code_4":1120,"Station_Name":"彰化","Station_EName":"Changhua","Station_Code_3":149,"WebsiteName":"彰化站","EnglishName":"Changhua","ChineseAddress":"彰化市三民路1號","EnglishAddress":"No.1, Sanmin Rd., Changhua City, Changhua County , Taiwan (R.O.C.)","Telephone":"04-7278263","gps":"24.081666,120.538539"},{"Station_Code_4":1202,"Station_Name":"花壇","Station_EName":"Huatan","Station_Code_3":150,"WebsiteName":"花壇站","EnglishName":"Huatan","ChineseAddress":"彰化縣花壇鄉中正路370號","EnglishAddress":"No.370, Zhongzheng Rd., Huatan Township, Changhua County , Taiwan (R.O.C.)","Telephone":"04-7881418","gps":"24.024997,120.537400"},{"Station_Code_4":1240,"Station_Name":"大村","Station_EName":"Dacun","Station_Code_3":227,"WebsiteName":"大村站","EnglishName":"Dacun","ChineseAddress":"彰化縣大村鄉過溝村福進路100號","EnglishAddress":"No.100, Fuxin Rd., Dacun Township, Changhua County, Taiwan (R.O.C.)","Telephone":"04-8525148","gps":"23.990053,120.560645"},{"Station_Code_4":1203,"Station_Name":"員林","Station_EName":"Yuanlin","Station_Code_3":151,"WebsiteName":"員林站","EnglishName":"Yuanlin","ChineseAddress":"彰化縣員林鎮民權街55號","EnglishAddress":"No.55, Minquan St., Yuanlin Township, Changhua County , Taiwan (R.O.C.)","Telephone":"04-8320544","gps":"23.959258,120.56965"},{"Station_Code_4":1204,"Station_Name":"永靖","Station_EName":"Yongjing","Station_Code_3":152,"WebsiteName":"永靖站","EnglishName":"Yongjing","ChineseAddress":"彰化縣永靖鄉崙子村永崙路25號","EnglishAddress":"No.25, Yonglun Rd., Yongjing Township, Changhua County , Taiwan (R.O.C.)","Telephone":"04-8320544","gps":"23.928148,120.571672"},{"Station_Code_4":1205,"Station_Name":"社頭","Station_EName":"Shetou","Station_Code_3":153,"WebsiteName":"社頭站","EnglishName":"Shetou","ChineseAddress":"彰化縣社頭鄉廣興村社站路10號","EnglishAddress":"No.10, Shezhan Rd., Shetou Township, Changhua County , Taiwan (R.O.C.)","Telephone":"04-8711646","gps":"23.895710,120.580800"},{"Station_Code_4":1206,"Station_Name":"田中","Station_EName":"Tianzhong","Station_Code_3":154,"WebsiteName":"田中站","EnglishName":"Tianzhong","ChineseAddress":"彰化縣田中鎮中州路1段1號","EnglishAddress":"No.1, Sec. 1, Zhongzhou Rd., Tianzhong Township, Changhua County , Taiwan (R.O.C.)","Telephone":"04-8742142","gps":"23.858503,120.591396"},{"Station_Code_4":1208,"Station_Name":"林內","Station_EName":"Linnei","Station_Code_3":156,"WebsiteName":"林內站","EnglishName":"Linnei","ChineseAddress":"雲林縣林內鄉中山路42號","EnglishAddress":"No.42, Zhongshan Rd., Linnei Township, Yunlin County , Taiwan (R.O.C.)","Telephone":"05-5892040","gps":"23.759681,120.614987"},{"Station_Code_4":1209,"Station_Name":"石榴","Station_EName":"Shiliu","Station_Code_3":157,"WebsiteName":"石榴站","EnglishName":"Shiliu","ChineseAddress":"雲林縣斗六市榴北里文明路26號","EnglishAddress":"No.26, Wenming Rd., Douliu City, Yunlin County , Taiwan (R.O.C.)","Telephone":"05-5332900","gps":"23.731643,120.579973"},{"Station_Code_4":1210,"Station_Name":"斗六","Station_EName":"Douliu","Station_Code_3":158,"WebsiteName":"斗六站","EnglishName":"Douliu","ChineseAddress":"雲林縣斗六市信義里民生路187號","EnglishAddress":"No.187, Minsheng Rd., Douliu City, Yunlin County , Taiwan (R.O.C.)","Telephone":"05-5332900","gps":"23.711813,120.541146"},{"Station_Code_4":1211,"Station_Name":"斗南","Station_EName":"Dounan","Station_Code_3":159,"WebsiteName":"斗南站","EnglishName":"Dounan","ChineseAddress":"雲林縣斗南鎮南昌里中山路2號","EnglishAddress":"No.2, Zhongshan Rd., Dounan Township, Yunlin County , Taiwan (R.O.C.)","Telephone":"05-5972039","gps":"23.672972,120.480841"},{"Station_Code_4":1212,"Station_Name":"石龜","Station_EName":"Shigui","Station_Code_3":160,"WebsiteName":"石龜站","EnglishName":"Shigui","ChineseAddress":"雲林縣斗南鎮石溪里","EnglishAddress":"Shigui , Dounan Township, Yunlin County , Taiwan (R.O.C.)","Telephone":"05-5972039","gps":"23.639568,120.471007"},{"Station_Code_4":1213,"Station_Name":"大林","Station_EName":"Dalin","Station_Code_3":161,"WebsiteName":"大林站","EnglishName":"Dalin","ChineseAddress":"嘉義縣大林鎮吉林里中山路2號","EnglishAddress":"No.2, Zhongshan Rd., Dalin Township, Chiayi County , Taiwan (R.O.C.)","Telephone":"05-2654804","gps":"23.601076,120.455839"},{"Station_Code_4":1214,"Station_Name":"民雄","Station_EName":"Minxiong","Station_Code_3":162,"WebsiteName":"民雄站","EnglishName":"Minxiong","ChineseAddress":"嘉義縣民雄鄉東榮村和平路2號","EnglishAddress":"No.2, Heping Rd., Minxiong Township, Chiayi County , Taiwan (R.O.C.)","Telephone":"05-2264272","gps":"23.555039,120.431651"},{"Station_Code_4":1215,"Station_Name":"嘉義","Station_EName":"Chiayi","Station_Code_3":163,"WebsiteName":"嘉義站","EnglishName":"Chiayi","ChineseAddress":"嘉義市中山路528號(含前、後站)","EnglishAddress":"No.528, Zhongshan Rd., West Dist., Chiayi City , Taiwan (R.O.C.)","Telephone":"05-2228904","gps":"23.479139,120.441026"},{"Station_Code_4":1217,"Station_Name":"水上","Station_EName":"Shuishang","Station_Code_3":164,"WebsiteName":"水上站","EnglishName":"Shuishang","ChineseAddress":"嘉義縣水上鄉粗溪村68號","EnglishAddress":"No.68 , Cuxi county ,Shuishang Township, Chiayi County , Taiwan (R.O.C.)","Telephone":"05-2228904","gps":"23.433995,120.399665"},{"Station_Code_4":1218,"Station_Name":"南靖","Station_EName":"Nanjing","Station_Code_3":165,"WebsiteName":"南靖站","EnglishName":"Nanjing","ChineseAddress":"嘉義縣水上鄉三鎮村26號","EnglishAddress":"No.26 , Sanzhen county ,Shuishang Township, Chiayi County , Taiwan (R.O.C.)","Telephone":"05-2601232","gps":"23.41345,120.386544"},{"Station_Code_4":1219,"Station_Name":"後壁","Station_EName":"Houbi","Station_Code_3":166,"WebsiteName":"後壁站","EnglishName":"Houbi","ChineseAddress":"臺南市後壁區後壁里77號","EnglishAddress":"No.77, Houbi, Houbi Dist., Tainan City , Taiwan (R.O.C.)","Telephone":"06-6872055","gps":"23.366290, 120.360517"},{"Station_Code_4":1220,"Station_Name":"新營","Station_EName":"Xinying","Station_Code_3":167,"WebsiteName":"新營站","EnglishName":"Xinying","ChineseAddress":"臺南市新營區中營里中山路1號","EnglishAddress":"No.1, Zhongshan Rd., Xinying Dist., Tainan City , Taiwan (R.O.C.)","Telephone":"06-6322104","gps":"23.306732,120.323055"},{"Station_Code_4":1221,"Station_Name":"柳營","Station_EName":"Liuying","Station_Code_3":168,"WebsiteName":"柳營站","EnglishName":"Liuying","ChineseAddress":"臺南市柳營區建國路1號","EnglishAddress":"No.1, Jianguo Rd., Liuying Dist., Tainan City , Taiwan (R.O.C.)","Telephone":"06-6226450","gps":"23.277737, 120.322304"},{"Station_Code_4":1222,"Station_Name":"林鳳營","Station_EName":"Linfengying","Station_Code_3":169,"WebsiteName":"林鳳營","EnglishName":"Linfengying","ChineseAddress":"臺南市六甲區中社里林鳳營16號","EnglishAddress":"No.16, Linfengying, Liujia Dist., Tainan City , Taiwan (R.O.C.)","Telephone":"06-6986086","gps":"23.242590, 120.320930"},{"Station_Code_4":1223,"Station_Name":"隆田","Station_EName":"Longtian","Station_Code_3":170,"WebsiteName":"隆田站","EnglishName":"Longtian","ChineseAddress":"臺南市官田區隆田里中山路1段1號","EnglishAddress":"No.1, Sec. 1, Zhongshan Rd., Guantian Dist., Tainan City , Taiwan (R.O.C.)","Telephone":"06-5791664","gps":"23.192699,120.31929"},{"Station_Code_4":1224,"Station_Name":"拔林","Station_EName":"Balin","Station_Code_3":171,"WebsiteName":"拔林站","EnglishName":"Balin","ChineseAddress":"臺南市官田區拔林里83之1號","EnglishAddress":"No.83-1, Bazilin, Guantian Dist., Tainan City, Taiwan (R.O.C.)","Telephone":"06-5791664","gps":"23.172622,120.32133"},{"Station_Code_4":1225,"Station_Name":"善化","Station_EName":"Shanhua","Station_Code_3":172,"WebsiteName":"善化站","EnglishName":"Shanhua","ChineseAddress":"臺南市善化區中山路1號","EnglishAddress":"No.1, Zhongshan Rd., Shanhua Dist., Tainan City , Taiwan (R.O.C.)","Telephone":"06-5837301","gps":"23.133323,120.306551"},{"Station_Code_4":1244,"Station_Name":"南科","Station_EName":"Nanke","Station_Code_3":282,"WebsiteName":"南科站","EnglishName":"Nanke","ChineseAddress":"臺南市新市區大營里大營村287-300號","EnglishAddress":"No.287-300, Daying county , Xinshi Dist., Tainan City , Taiwan (R.O.C.)","Telephone":"06-5896356","gps":"23.107602,120.301996"},{"Station_Code_4":1226,"Station_Name":"新市","Station_EName":"Xinshi","Station_Code_3":173,"WebsiteName":"新市站","EnglishName":"Xinshi","ChineseAddress":"臺南市新市區新和里中華路1號","EnglishAddress":"No.1, Zhonghua Rd., Xinshi Dist., Tainan City , Taiwan (R.O.C.)","Telephone":"06-5996911","gps":"23.06823,120.290035"},{"Station_Code_4":1227,"Station_Name":"永康","Station_EName":"Yongkang","Station_Code_3":174,"WebsiteName":"永康站","EnglishName":"Yongkang","ChineseAddress":"臺南市永康區埔園里中山路459號","EnglishAddress":"No.459, Zhongshan Rd., Yongkang Dist., Tainan City , Taiwan (R.O.C.)","Telephone":"06-2323305","gps":"23.038338,120.253524"},{"Station_Code_4":1239,"Station_Name":"大橋","Station_EName":"Daqiao","Station_Code_3":226,"WebsiteName":"大橋站","EnglishName":"Daqiao","ChineseAddress":"臺南市永康區中華路835號","EnglishAddress":"No.835, Zhonghua Rd., Yongkang Dist., Tainan City , Taiwan (R.O.C.)","Telephone":"06-3021755","gps":"23.019399,120.224420"},{"Station_Code_4":1228,"Station_Name":"臺南","Station_EName":"Tainan","Station_Code_3":175,"WebsiteName":"臺南站","EnglishName":"Tainan","ChineseAddress":"臺南市東區北門路2段4號","EnglishAddress":"No.4, Sec. 2, Beimen Rd., East Dist., Tainan City , Taiwan (R.O.C.)","Telephone":"06-2261314","gps":"22.997144,120.212966"},{"Station_Code_4":1231,"Station_Name":"大湖","Station_EName":"Dahu","Station_Code_3":178,"WebsiteName":"大湖站","EnglishName":"Dahu","ChineseAddress":"高雄市路竹區甲南里天佑路24號","EnglishAddress":"No.24, Tianyou Rd., Luzhu Dist., Kaohsiung City , Taiwan (R.O.C.)","Telephone":"07-6932127","gps":"22.878228,120.253934"},{"Station_Code_4":1232,"Station_Name":"路竹","Station_EName":"Luzhu","Station_Code_3":179,"WebsiteName":"路竹站","EnglishName":"Luzhu","ChineseAddress":"高雄市路竹區竹南里中正路288號","EnglishAddress":"No.288, Zhongzheng Rd., Luzhu Dist., Kaohsiung City , Taiwan (R.O.C.)","Telephone":"07-6072723","gps":"22.853948,120.266275"},{"Station_Code_4":1233,"Station_Name":"岡山","Station_EName":"Gangshan","Station_Code_3":180,"WebsiteName":"岡山站","EnglishName":"Gangshan","ChineseAddress":"高雄市岡山區岡燕路111號","EnglishAddress":"No.111, Gangyan Rd., Gangshan Dist., Kaohsiung City , Taiwan (R.O.C.)","Telephone":"07-6212074","gps":"22.792355,120.299933"},{"Station_Code_4":1234,"Station_Name":"橋頭","Station_EName":"Qiaotou","Station_Code_3":181,"WebsiteName":"橋頭站","EnglishName":"Qiaotou","ChineseAddress":"高雄市橋頭區橋頭里站前街14號","EnglishAddress":"No.14, Zhanqian St., Qiaotou Dist., Kaohsiung City , Taiwan (R.O.C.)","Telephone":"07-6115424","gps":"22.760994,120.310334"},{"Station_Code_4":1235,"Station_Name":"楠梓","Station_EName":"Nanzi","Station_Code_3":183,"WebsiteName":"楠梓站","EnglishName":"Nanzi","ChineseAddress":"高雄市楠梓區建楠路229號","EnglishAddress":"No.229, Jiannan Rd., Nanzi Dist., Kaohsiung City , Taiwan (R.O.C.)","Telephone":"07-3510175","gps":"22.727035,120.324371"},{"Station_Code_4":1236,"Station_Name":"左營","Station_EName":"Zuoying","Station_Code_3":184,"WebsiteName":"左營站","EnglishName":"Zuoying","ChineseAddress":"高雄市左營區勝利路1號","EnglishAddress":"No.1, Shengli Rd., Zuoying Dist., Kaohsiung City , Taiwan (R.O.C.)","Telephone":"07-5887825","gps":"22.675204,120.294793"},{"Station_Code_4":1238,"Station_Name":"高雄","Station_EName":"Kaohsiung","Station_Code_3":185,"WebsiteName":"高雄站","EnglishName":"Kaohsiung","ChineseAddress":"高雄市三民區建國二路318號","EnglishAddress":"No.318, Jianguo 2nd Rd., Sanmin Dist., Kaohsiung City , Taiwan (R.O.C.)","Telephone":"07-2352376","gps":"22.639620,120.302111"},{"Station_Code_4":1229,"Station_Name":"保安","Station_EName":"Baoan","Station_Code_3":176,"WebsiteName":"保安站","EnglishName":"Baoan","ChineseAddress":"臺南市仁德區保安里文賢路1段529巷10號","EnglishAddress":"No.10, Ln. 529, Sec. 1, Wenxian Rd., Rende Dist., Tainan City , Taiwan (R.O.C.)","Telephone":"06-2665988","gps":"22.932940,120.231594"},{"Station_Code_4":1207,"Station_Name":"二水","Station_EName":"Ershui","Station_Code_3":155,"WebsiteName":"二水站","EnglishName":"Ershui","ChineseAddress":"彰化縣二水鄉光文路1號","EnglishAddress":"No.1, Guangwen Rd., Ershui Township, Changhua County , Taiwan (R.O.C.)","Telephone":"04-8792027","gps":"23.813150,120.618115"},{"Station_Code_4":1241,"Station_Name":"嘉北","Station_EName":"Jiabei","Station_Code_3":228,"WebsiteName":"嘉北站","EnglishName":"Jiabei","ChineseAddress":"嘉義市後湖里保健街110號","EnglishAddress":"No.110, Baojian St., East Dist., Chiayi City , Taiwan (R.O.C.)","Telephone":"05-2334584","gps":"23.499897,120.448503"},{"Station_Code_4":1242,"Station_Name":"新左營","Station_EName":"Xinzuoying","Station_Code_3":288,"WebsiteName":"新左營站","EnglishName":"Xinzuoying","ChineseAddress":"高雄市左營區尾北里站前北路1號","EnglishAddress":"No.1, Zhanqian N. Rd., Zuoying Dist., Kaohsiung City , Taiwan (R.O.C.)","Telephone":"07-5887825","gps":"22.687544,120.306788"},{"Station_Code_4":1243,"Station_Name":"仁德","Station_EName":"Rende","Station_Code_3":281,"WebsiteName":"仁德站","EnglishName":"Rende","ChineseAddress":"臺南市仁德區保安里永德路10號","EnglishAddress":"No.10, Yongde Rd., Rende Dist., Tainan City , Taiwan (R.O.C.)","Telephone":"06-2669383","gps":"22.923682,120.240609"},{"Station_Code_4":1230,"Station_Name":"中洲","Station_EName":"Zhongzhou","Station_Code_3":177,"WebsiteName":"中洲站","EnglishName":"Zhongzhou","ChineseAddress":"臺南市仁德區中洲路298之1號","EnglishAddress":"No.298-1, Zhongzhou Rd., Rende Dist., Tainan City , Taiwan (R.O.C.)","Telephone":"06-2667191","gps":"22.904544,120.2527"},{"Station_Code_4":1302,"Station_Name":"造橋","Station_EName":"Zaoqiao","Station_Code_3":135,"WebsiteName":"造橋站","EnglishName":"Zaoqiao","ChineseAddress":"苗栗縣造橋鄉造橋村平仁路54號","EnglishAddress":"No.54, Pingren , Zaoqiao Township, Miaoli County , Taiwan (R.O.C.)","Telephone":"037-472030","gps":"24.641439,120.867051"},{"Station_Code_4":1304,"Station_Name":"豐富","Station_EName":"Fengfu","Station_Code_3":136,"WebsiteName":"豐富站","EnglishName":"Fengfu","ChineseAddress":"苗栗縣後龍鎮校椅里高鐵一路66號","EnglishAddress":"No.66, Gaotie 1st Rd., Houlong Township, Miaoli County 356, Taiwan (R.O.C.)","Telephone":"037-260031","gps":"24.6044168,120.8261147"},{"Station_Code_4":1305,"Station_Name":"苗栗","Station_EName":"Miaoli","Station_Code_3":137,"WebsiteName":"苗栗站","EnglishName":"Miaoli","ChineseAddress":"苗栗市為公路1號","EnglishAddress":"No.1, Weigong Rd., Miaoli City, Miaoli County , Taiwan (R.O.C.)","Telephone":"037-260031","gps":"24.570036,120.822319"},{"Station_Code_4":1307,"Station_Name":"南勢","Station_EName":"Nanshi","Station_Code_3":138,"WebsiteName":"南勢站","EnglishName":"Nanshi","ChineseAddress":"苗栗市新英里南勢39號","EnglishAddress":"No.39, Nanshi, Miaoli City, Miaoli County , Taiwan (R.O.C.)","Telephone":"037-260031","gps":"24.522509,120.791571"},{"Station_Code_4":1308,"Station_Name":"銅鑼","Station_EName":"Tongluo","Station_Code_3":139,"WebsiteName":"銅鑼站","EnglishName":"Tongluo","ChineseAddress":"苗栗縣銅鑼鄉銅鑼村大同路13號","EnglishAddress":"No.13, Datong Rd., Tongluo Township, Miaoli County , Taiwan (R.O.C.)","Telephone":"037-983838","gps":"24.486340,120.786173"},{"Station_Code_4":1310,"Station_Name":"三義","Station_EName":"Sanyi","Station_Code_3":140,"WebsiteName":"三義站","EnglishName":"Sanyi","ChineseAddress":"苗栗縣三義鄉雙湖村90號","EnglishAddress":"No.90, Shuanghu, Sanyi Township, Miaoli County , Taiwan (R.O.C.)","Telephone":"037-874763","gps":"24.420620,120.773931"},{"Station_Code_4":1314,"Station_Name":"泰安","Station_EName":"Taian","Station_Code_3":142,"WebsiteName":"泰安站","EnglishName":"Taian","ChineseAddress":"臺中巿后里區安眉路37-12號","EnglishAddress":"No.37-12, Anmei Rd., Houli Dist., Taichung City , Taiwan (R.O.C.)","Telephone":"04-25562038","gps":"24.331292,120.741816"},{"Station_Code_4":1315,"Station_Name":"后里","Station_EName":"Houli","Station_Code_3":143,"WebsiteName":"后里站","EnglishName":"Houli","ChineseAddress":"臺中市后里區甲后路1號","EnglishAddress":"No.1, Jiahou Rd., Houli Dist., Taichung City , Taiwan (R.O.C.)","Telephone":"04-25562038","gps":"24.309312,120.732893"},{"Station_Code_4":1317,"Station_Name":"豐原","Station_EName":"Fengyuan","Station_Code_3":144,"WebsiteName":"豐原站","EnglishName":"Fengyuan","ChineseAddress":"臺中市豐原區中正路1號","EnglishAddress":"No.1, Zhongzheng Rd., Fengyuan Dist., Taichung City , Taiwan (R.O.C.)","Telephone":"04-25207950","gps":"24.254111, 120.723447"},{"Station_Code_4":1318,"Station_Name":"潭子","Station_EName":"Tanzi","Station_Code_3":145,"WebsiteName":"潭子站","EnglishName":"Tanzi","ChineseAddress":"臺中市潭子區中山路二段352號","EnglishAddress":"No.352, Sec. 2, Zhongshan Rd., Tanzi Dist., Taichung City , Taiwan (R.O.C.)","Telephone":"04-25319200","gps":"24.212802,120.705947"},{"Station_Code_4":1323,"Station_Name":"太原","Station_EName":"Taiyuan","Station_Code_3":225,"WebsiteName":"太原站","EnglishName":"Taiyuan","ChineseAddress":"臺中市東光路833號","EnglishAddress":"No.833, Donguan Rd., Beitun Dist., Taichung City , Taiwan (R.O.C.)","Telephone":"04-22313926","gps":"24.163634, 120.699717"},{"Station_Code_4":1319,"Station_Name":"臺中","Station_EName":"Taichung","Station_Code_3":146,"WebsiteName":"臺中站","EnglishName":"Taichung","ChineseAddress":"臺中市中區臺灣大道一段1號","EnglishAddress":"No.1, Sec. 1, Taiwan Blvd., Central Dist., Taichung City 400, Taiwan (R.O.C.)","Telephone":"04-22216492","gps":"24.136955, 120.686827"},{"Station_Code_4":1322,"Station_Name":"大慶","Station_EName":"Daqing","Station_Code_3":223,"WebsiteName":"大慶站","EnglishName":"Daqing","ChineseAddress":"臺中市建國路80號(對面)","EnglishAddress":"No.80, Jianguo Rd., South Dist., Taichung City , Taiwan (R.O.C.)","Telephone":"04-22637940","gps":"24.119304, 120.648571"},{"Station_Code_4":1320,"Station_Name":"烏日","Station_EName":"Wuri","Station_Code_3":147,"WebsiteName":"烏日站","EnglishName":"Wuri","ChineseAddress":"臺中市烏日區三民街258號","EnglishAddress":"No.258, Sanmin St., Wuri Dist., Taichung City , Taiwan (R.O.C.)","Telephone":"04-23381071","gps":"24.108692,120.622472"},{"Station_Code_4":1324,"Station_Name":"新烏日","Station_EName":"Xinwuri","Station_Code_3":280,"WebsiteName":"新烏日站","EnglishName":"Xinwuri","ChineseAddress":"臺中市烏日區高鐵東一路26號","EnglishAddress":"No.26, Gaotie E. 1st Rd., Wuri Dist., Taichung City , Taiwan (R.O.C.)","Telephone":"04-23376883","gps":"24.109851,120.614309"},{"Station_Code_4":1321,"Station_Name":"成功","Station_EName":"Chenggong","Station_Code_3":148,"WebsiteName":"成功站","EnglishName":"Chenggong","ChineseAddress":"臺中市烏日區中山路3段550號","EnglishAddress":"No.550, Sec. 3, Zhongshan Rd., Wuri Dist., Taichung City , Taiwan (R.O.C.)","Telephone":"04-23371986","gps":"24.114232,120.590164"},{"Station_Code_4":1402,"Station_Name":"鳳山","Station_EName":"Fengshan","Station_Code_3":186,"WebsiteName":"鳳山站","EnglishName":"Fengshan","ChineseAddress":"高雄市鳳山區曹公路70號","EnglishAddress":"No.70, Caogong Rd., Fengshan Dist., Kaohsiung City , Taiwan (R.O.C.)","Telephone":"07-7460423","gps":"22.631284,120.357683"},{"Station_Code_4":1403,"Station_Name":"後庄","Station_EName":"Houzhuang","Station_Code_3":187,"WebsiteName":"後庄站","EnglishName":"Houzhuang","ChineseAddress":"高雄市大寮區民慶街9號","EnglishAddress":"No.9, Minqing St., Daliao Dist., Kaohsiung City , Taiwan (R.O.C.)","Telephone":"07-7020149","gps":"22.640067,120.391125"},{"Station_Code_4":1404,"Station_Name":"九曲堂","Station_EName":"Jiuqutang","Station_Code_3":188,"WebsiteName":"九曲堂站","EnglishName":"Jiuqutang","ChineseAddress":"高雄市大樹區久堂里鐵路巷15號","EnglishAddress":"No.15, Railway Ln., Jiutang Rd., Dashu Dist., Kaohsiung City , Taiwan (R.O.C.)","Telephone":"07-6512020","gps":"22.656423, 120.420879"},{"Station_Code_4":1405,"Station_Name":"六塊厝","Station_EName":"Liukuaicuo","Station_Code_3":189,"WebsiteName":"六塊厝站","EnglishName":"Liukuaicuo","ChineseAddress":"屏東縣屏東市長安里光復路392號","EnglishAddress":"No.392, Guangfu Rd., Pingtung City, Pingtung County , Taiwan (R.O.C.)","Telephone":"08-7515140","gps":"22.666252,120.464873"},{"Station_Code_4":1406,"Station_Name":"屏東","Station_EName":"Pingtung","Station_Code_3":190,"WebsiteName":"屏東站","EnglishName":"Pingtung","ChineseAddress":"屏東市光復路43號","EnglishAddress":"No.43, Guangfu Rd., Pingtung City, Pingtung County , Taiwan (R.O.C.)\\","Telephone":"08-7655240","gps":"22.669306,120.486203"},{"Station_Code_4":1407,"Station_Name":"歸來","Station_EName":"Guilai","Station_Code_3":191,"WebsiteName":"歸來站","EnglishName":"Guilai","ChineseAddress":"屏東縣屏東市歸來里歸仁路5-4號","EnglishAddress":"No.5-4, Guiren Rd., Pingtung City, Pingtung County , Taiwan (R.O.C.)","Telephone":"08-7515140","gps":"22.65238,120.502941"},{"Station_Code_4":1408,"Station_Name":"麟洛","Station_EName":"Linluo","Station_Code_3":192,"WebsiteName":"麟洛站","EnglishName":"Linluo","ChineseAddress":"屏東縣麟洛鄉田道村緀仔一路","EnglishAddress":"Qizi ist Rd. , Linluo Township, Pingtung County 909, Taiwan (R.O.C.)","Telephone":"08-7515140","gps":"22.634849,120.514378"},{"Station_Code_4":1409,"Station_Name":"西勢","Station_EName":"Xishi","Station_Code_3":193,"WebsiteName":"西勢站","EnglishName":"Xishi","ChineseAddress":"屏東縣竹田鄉西勢村西豐路2號","EnglishAddress":"No.2, Xifeng Rd., Zhutian Township, Pingtung County , Taiwan (R.O.C.)","Telephone":"08-7784521","gps":"22.616433,120.526697"},{"Station_Code_4":1410,"Station_Name":"竹田","Station_EName":"Zhutian","Station_Code_3":194,"WebsiteName":"竹田站","EnglishName":"Zhutian","ChineseAddress":"屏東縣竹田鄉履豐村豐明路27-1號","EnglishAddress":"No.27-1, Fengming Rd., Zhutian Township, Pingtung County , Taiwan (R.O.C.)","Telephone":"08-7711002","gps":"22.586491,120.540002"},{"Station_Code_4":1411,"Station_Name":"潮州","Station_EName":"Chaozhou","Station_Code_3":195,"WebsiteName":"潮州站","EnglishName":"Chaozhou","ChineseAddress":"屏東縣潮州鎮信義路111號","EnglishAddress":"No.111, Xinyi Rd., Chaozhou Township, Pingtung County , Taiwan (R.O.C.)","Telephone":"08-7882739","gps":"22.550086,120.536420"},{"Station_Code_4":1412,"Station_Name":"崁頂","Station_EName":"Kanding","Station_Code_3":196,"WebsiteName":"崁頂站","EnglishName":"Kanding","ChineseAddress":"屏東市崁頂鄉崁頂村中正路122號","EnglishAddress":"No.122, Zhongzheng Rd., Kanding Township, Pingtung County , Taiwan (R.O.C.)","Telephone":"08-7882739","gps":"22.51306,120.514765"},{"Station_Code_4":1413,"Station_Name":"南州","Station_EName":"Nanzhou","Station_Code_3":197,"WebsiteName":"南州站","EnglishName":"Nanzhou","ChineseAddress":"屏東縣南州鄉仁里村仁里路86號","EnglishAddress":"No.86, Renli Rd., Nanzhou Township, Pingtung County , Taiwan (R.O.C.)","Telephone":"08-8642942","gps":"22.492058,120.511738"},{"Station_Code_4":1414,"Station_Name":"鎮安","Station_EName":"Zhenan","Station_Code_3":198,"WebsiteName":"鎮安站","EnglishName":"Zhenan","ChineseAddress":"屏東縣林邊鄉鎮安村永和路4號","EnglishAddress":"No.4, Yonghe Rd., Linbian Township, Pingtung County , Taiwan (R.O.C.)","Telephone":"08-8642942","gps":"22.457984,120.511356"},{"Station_Code_4":1415,"Station_Name":"林邊","Station_EName":"Linbian","Station_Code_3":199,"WebsiteName":"林邊站","EnglishName":"Linbian","ChineseAddress":"屏東縣林邊鄉仁和村仁愛路33號","EnglishAddress":"No.33, Ren’ai Rd., Linbian Township, Pingtung County , Taiwan (R.O.C.)","Telephone":"08-8751475","gps":"22.431406,120.515376"},{"Station_Code_4":1416,"Station_Name":"佳冬","Station_EName":"Jiadong","Station_Code_3":200,"WebsiteName":"佳冬站","EnglishName":"Jiadong","ChineseAddress":"屏東縣佳冬鄉六根村復興路21號","EnglishAddress":"No.21, Fuxing Rd., Jiadong Township, Pingtung County , Taiwan (R.O.C.)","Telephone":"08-8662939","gps":"22.414087,120.547742"},{"Station_Code_4":1417,"Station_Name":"東海","Station_EName":"Donghai","Station_Code_3":201,"WebsiteName":"東海站","EnglishName":"Donghai","ChineseAddress":"屏東縣枋寮鄉東海村西安路92號","EnglishAddress":"No.92, Xi’an Rd., Fangliao Township, Pingtung County , Taiwan (R.O.C.)","Telephone":"08-8782041","gps":"22.399005,120.572381"},{"Station_Code_4":1418,"Station_Name":"枋寮","Station_EName":"Fangliao","Station_Code_3":203,"WebsiteName":"枋寮站","EnglishName":"Fangliao","ChineseAddress":"屏東縣枋寮鄉枋寮村儲運路18號","EnglishAddress":"No.18, Chuyun Rd., Fangliao Township, Pingtung County , Taiwan (R.O.C.)","Telephone":"08-8782041","gps":"22.368019,120.595098"},{"Station_Code_4":1502,"Station_Name":"加祿","Station_EName":"Jialu","Station_Code_3":204,"WebsiteName":"加祿站","EnglishName":"Jialu","ChineseAddress":"屏東縣枋山鄉加祿村會社路53號","EnglishAddress":"No.53, Huishe Rd. , Fangshan Township, Pingtung County , Taiwan (R.O.C.)","Telephone":"08-8720791","gps":"22.330971,120.624621"},{"Station_Code_4":1503,"Station_Name":"內獅","Station_EName":"Neishi","Station_Code_3":205,"WebsiteName":"內獅站","EnglishName":"Neishi","ChineseAddress":"屏東縣枋山鄉加祿村南和路43號","EnglishAddress":"No.43, Nanhe Rd., Fangshan Township, Pingtung County , Taiwan (R.O.C.)","Telephone":"08-8720791","gps":"22.306184,120.643492"},{"Station_Code_4":1504,"Station_Name":"枋山","Station_EName":"Fangshan","Station_Code_3":206,"WebsiteName":"枋山站","EnglishName":"Fangshan","ChineseAddress":"屏東縣獅子鄉內獅村內獅巷84號","EnglishAddress":"No.84, Neishi Ln., Shizi Township, Pingtung County , Taiwan (R.O.C.)","Telephone":"08-8720791","gps":"22.267067,120.659647"},{"Station_Code_4":1505,"Station_Name":"枋野","Station_EName":"Fangye","Station_Code_3":207,"WebsiteName":"枋野站","EnglishName":"Fangye","ChineseAddress":"屏東縣獅子鄉內獅巷88號","EnglishAddress":"No.88, Neishi Ln., Shizi Township, Pingtung County , Taiwan (R.O.C.)","Telephone":"08-8761953","gps":"22.280818,120.717243"},{"Station_Code_4":1507,"Station_Name":"古莊","Station_EName":"Guzhuang","Station_Code_3":210,"WebsiteName":"古莊站","EnglishName":"Guzhuang","ChineseAddress":"臺東縣大武鄉尚武村古莊83號","EnglishAddress":"No.83, Guzhuang Rd., Dawu Township, Taitung County , Taiwan (R.O.C.)","Telephone":"089-791820","gps":"22.345509,120.878079"},{"Station_Code_4":1508,"Station_Name":"大武","Station_EName":"Dawu","Station_Code_3":211,"WebsiteName":"大武站","EnglishName":"Dawu","ChineseAddress":"臺東縣大武鄉大鳥村和平部落33號","EnglishAddress":"No.33, Heping, Dawu Township, Taitung County , Taiwan (R.O.C.)","Telephone":"089-792056","gps":"22.365206,120.900713"},{"Station_Code_4":1510,"Station_Name":"瀧溪","Station_EName":"Longxi","Station_Code_3":213,"WebsiteName":"瀧溪站","EnglishName":"Longxi","ChineseAddress":"臺東縣太麻里鄉多良村大溪14鄰37之1號","EnglishAddress":"No.37-1, Daxi, Taimali Township, Taitung County , Taiwan (R.O.C.)","Telephone":"089-761482","gps":"22.46104,120.941771"},{"Station_Code_4":1512,"Station_Name":"金崙","Station_EName":"Jinlun","Station_Code_3":215,"WebsiteName":"金崙站","EnglishName":"Jinlun","ChineseAddress":"臺東縣太麻里鄉金崙村47-17號","EnglishAddress":"No.47-17, Jinlun, Taimali Township, Taitung County , Taiwan (R.O.C.)","Telephone":"089-771068","gps":"22.531488,120.967239"},{"Station_Code_4":1514,"Station_Name":"太麻里","Station_EName":"Taimali","Station_Code_3":217,"WebsiteName":"太麻里站","EnglishName":"Taimali","ChineseAddress":"臺東縣太麻里鄉大王村276-13號","EnglishAddress":"No.276-13, Dawang Rd., Taimali Township, Taitung County , Taiwan (R.O.C.)","Telephone":"089-781544","gps":"22.614936,120.993368"},{"Station_Code_4":1516,"Station_Name":"知本","Station_EName":"Zhiben","Station_Code_3":219,"WebsiteName":"知本站","EnglishName":"Zhiben","ChineseAddress":"臺東市知本路二段900巷85號","EnglishAddress":"No.85, Ln. 900, Sec. 2, Zhiben Rd., Taitung City, Taitung County , Taiwan (R.O.C.)","Telephone":"089-514482","gps":"22.710182,121.060744"},{"Station_Code_4":1517,"Station_Name":"康樂","Station_EName":"Kangle","Station_Code_3":220,"WebsiteName":"康樂站","EnglishName":"Kangle","ChineseAddress":"台東市博物館路51巷131號","EnglishAddress":"No.131, Ln. 51, Museum Rd., Taitung City, Taitung County , Taiwan (R.O.C.)","Telephone":"089-383107","gps":"22.764277,121.09356"},{"Station_Code_4":1602,"Station_Name":"吉安","Station_EName":"Jian","Station_Code_3":45,"WebsiteName":"吉安站","EnglishName":"Jian","ChineseAddress":"花蓮縣吉安鄉南昌街200號","EnglishAddress":"No.200, Nanchang St., Ji’an Township, Hualien County , Taiwan (R.O.C.)","Telephone":"03-8539423","gps":"23.968179,121.582699"},{"Station_Code_4":1604,"Station_Name":"志學","Station_EName":"Zhixue","Station_Code_3":43,"WebsiteName":"志學站","EnglishName":"Zhixue","ChineseAddress":"花蓮縣壽豐鄉中正路1號","EnglishAddress":"No.1, Zhongzheng Rd., Shoufeng Township, Hualien County , Taiwan (R.O.C.)","Telephone":"03-8662966","gps":"23.907494,121.529437"},{"Station_Code_4":1605,"Station_Name":"平和","Station_EName":"Pinghe","Station_Code_3":42,"WebsiteName":"平和站","EnglishName":"Pinghe","ChineseAddress":"花蓮縣壽豐鄉平和路1號","EnglishAddress":"No.1, Pinghe Rd., Shoufeng Township, Hualien County , Taiwan (R.O.C.)","Telephone":"03-8653706","gps":"23.882774,121.520485"},{"Station_Code_4":1606,"Station_Name":"壽豐","Station_EName":"Shoufeng","Station_Code_3":41,"WebsiteName":"壽豐站","EnglishName":"Shoufeng","ChineseAddress":"花蓮縣壽豐鄉壽山路1號","EnglishAddress":"No.1, Shoushan Rd., Shoufeng Township, Hualien County , Taiwan (R.O.C.)","Telephone":"03-8653706","gps":"23.869016,121.510633"},{"Station_Code_4":1607,"Station_Name":"豐田","Station_EName":"Fengtian","Station_Code_3":40,"WebsiteName":"豐田站","EnglishName":"Fengtian","ChineseAddress":"花蓮縣壽豐鄉站前街36號","EnglishAddress":"No.36, Zhanqian St., Shoufeng Township, Hualien County , Taiwan (R.O.C.)","Telephone":"03-8654251","gps":"23.848475,121.496168"},{"Station_Code_4":1609,"Station_Name":"南平","Station_EName":"Nanping","Station_Code_3":37,"WebsiteName":"南平站","EnglishName":"Nanping","ChineseAddress":"花蓮縣鳳林鎮自強路233號","EnglishAddress":"No.233, Ziqiang Rd., Fenglin Township, Hualien County , Taiwan (R.O.C.)","Telephone":"03-8771597","gps":"23.782276,121.458280"},{"Station_Code_4":1610,"Station_Name":"鳳林","Station_EName":"Fenglin","Station_Code_3":36,"WebsiteName":"鳳林站","EnglishName":"Fenglin","ChineseAddress":"花蓮縣鳳林鎮中山路43號","EnglishAddress":"No.43, Zhongshan Rd., Fenglin Township, Hualien County , Taiwan (R.O.C.)","Telephone":"03-8762004","gps":"23.746340,121.447024"},{"Station_Code_4":1611,"Station_Name":"萬榮","Station_EName":"Wanrong","Station_Code_3":35,"WebsiteName":"萬榮站","EnglishName":"Wanrong","ChineseAddress":"花蓮縣鳳林鎮長德街17號","EnglishAddress":"No.17, Changde St., Fenglin Township, Hualien County , Taiwan (R.O.C.)","Telephone":"03-8752175","gps":"23.711978,121.419067"},{"Station_Code_4":1612,"Station_Name":"光復","Station_EName":"Guangfu","Station_Code_3":34,"WebsiteName":"光復站","EnglishName":"Guangfu","ChineseAddress":"花蓮縣光復鄉中正路1段2-1號","EnglishAddress":"No.2-1, Sec. 1, Zhongshan Rd., Guangfu Township, Hualien County , Taiwan (R.O.C.)","Telephone":"03-8704143","gps":"23.666293,121.421168"},{"Station_Code_4":1613,"Station_Name":"大富","Station_EName":"Dafu","Station_Code_3":32,"WebsiteName":"大富站","EnglishName":"Dafu","ChineseAddress":"花蓮縣光復鄉明德路1號","EnglishAddress":"No.1, Mingde Rd., Guangfu Township, Hualien County , Taiwan (R.O.C.)","Telephone":"03-8811824","gps":"23.605688,121.389624"},{"Station_Code_4":1614,"Station_Name":"富源","Station_EName":"Fuyuan","Station_Code_3":31,"WebsiteName":"富源站","EnglishName":"Fuyuan","ChineseAddress":"花蓮縣瑞穗鄉富源路2號","EnglishAddress":"No.2, Fuyuan Rd., Ruisui Township, Hualien County , Taiwan (R.O.C.)","Telephone":"03-8811824","gps":"23.580268,121.380122"},{"Station_Code_4":1616,"Station_Name":"瑞穗","Station_EName":"Ruisui","Station_Code_3":29,"WebsiteName":"瑞穗站","EnglishName":"Ruisui","ChineseAddress":"花蓮縣瑞穗鄉四維街13號","EnglishAddress":"No.13, Siwei St., Ruisui Township, Hualien County , Taiwan (R.O.C.)","Telephone":"03-8875039","gps":"23.497376,121.376841"},{"Station_Code_4":1617,"Station_Name":"三民","Station_EName":"Sanmin","Station_Code_3":27,"WebsiteName":"三民站","EnglishName":"Sanmin","ChineseAddress":"花蓮縣玉里鎮三民路10號","EnglishAddress":"No.10, Sanmin, Yuli Township, Hualien County , Taiwan (R.O.C.)","Telephone":"03-8841847","gps":"23.424766,121.345344"},{"Station_Code_4":1619,"Station_Name":"玉里","Station_EName":"Yuli","Station_Code_3":25,"WebsiteName":"玉里站","EnglishName":"Yuli","ChineseAddress":"花蓮縣玉里鎮康樂街39號","EnglishAddress":"No.39, Kangle St., Yuli Township, Hualien County , Taiwan (R.O.C.)","Telephone":"03-8882020","gps":"23.331518,121.311726"},{"Station_Code_4":1621,"Station_Name":"東里","Station_EName":"Dongli","Station_Code_3":22,"WebsiteName":"東里站","EnglishName":"Dongli","ChineseAddress":"花蓮縣富里鄉大莊路15號之6","EnglishAddress":"No.15-6, Dazhuang Rd., Fuli Township, Hualien County , Taiwan (R.O.C.)","Telephone":"03-8861005","gps":"23.272309,121.304181"},{"Station_Code_4":1622,"Station_Name":"東竹","Station_EName":"Dongzhu","Station_Code_3":20,"WebsiteName":"東竹站","EnglishName":"Dongzhu","ChineseAddress":"花蓮縣富里鄉新興村26號","EnglishAddress":"No.26, Xinxing, Fuli Township, Hualien County , Taiwan (R.O.C.)","Telephone":"03-8821504","gps":"23.226025,121.278481"},{"Station_Code_4":1623,"Station_Name":"富里","Station_EName":"Fuli","Station_Code_3":18,"WebsiteName":"富里站","EnglishName":"Fuli","ChineseAddress":"花蓮縣富里鄉車站街56號","EnglishAddress":"No.56, Chezhan St., Fuli Township, Hualien County , Taiwan (R.O.C.)","Telephone":"03-8831771","gps":"23.179132,121.248692"},{"Station_Code_4":1624,"Station_Name":"池上","Station_EName":"Chishang","Station_Code_3":15,"WebsiteName":"池上站","EnglishName":"Chishang","ChineseAddress":"臺東縣池上鄉鐵花路30號","EnglishAddress":"No.30, Tiehua Rd., Chishang Township, Taitung County , Taiwan (R.O.C.)","Telephone":"089-862097","gps":"23.126158,121.219390"},{"Station_Code_4":1625,"Station_Name":"海端","Station_EName":"Haiduan","Station_Code_3":14,"WebsiteName":"海端站","EnglishName":"Haiduan","ChineseAddress":"臺東縣關山鎮西莊49號","EnglishAddress":"No.49, Xizhuang, Guanshan Township, Taitung County , Taiwan (R.O.C.)","Telephone":"089-811033","gps":"23.102934,121.176829"},{"Station_Code_4":1626,"Station_Name":"關山","Station_EName":"Guanshan","Station_Code_3":12,"WebsiteName":"關山站","EnglishName":"Guanshan","ChineseAddress":"臺東縣關山鎮博愛路2號","EnglishAddress":"No.2, Bo’ai Rd., Guanshan Township, Taitung County , Taiwan (R.O.C.)","Telephone":"089-811033","gps":"23.045665,121.164373"},{"Station_Code_4":1628,"Station_Name":"瑞和","Station_EName":"Ruihe","Station_Code_3":10,"WebsiteName":"瑞和站","EnglishName":"Ruihe","ChineseAddress":"臺東縣鹿野鄉瑞和村瑞榮路1之1號","EnglishAddress":"No1-1 , Ruirong Rd. , Luye Township, Taitung County , Taiwan (R.O.C.)","Telephone":"089-580159","gps":"22.979968,121.15579"},{"Station_Code_4":1629,"Station_Name":"瑞源","Station_EName":"Ruiyuan","Station_Code_3":9,"WebsiteName":"瑞源站","EnglishName":"Ruiyuan","ChineseAddress":"臺東縣鹿野鄉瑞景路1段336巷8號之1","EnglishAddress":"No.8-1, Ln. 336, Sec. 1, Ruijing Rd., Luye Township, Taitung County , Taiwan (R.O.C.)","Telephone":"089-580159","gps":"22.955978,121.159014"},{"Station_Code_4":1630,"Station_Name":"鹿野","Station_EName":"Luye","Station_Code_3":8,"WebsiteName":"鹿野站","EnglishName":"Luye","ChineseAddress":"臺東縣鹿野鄉中正路38號","EnglishAddress":"No.38, Zhongzheng Rd., Luye Township, Taitung County , Taiwan (R.O.C.)","Telephone":"089-550217","gps":"22.912469,121.137004"},{"Station_Code_4":1631,"Station_Name":"山里","Station_EName":"Shanli","Station_Code_3":6,"WebsiteName":"山里站","EnglishName":"Shanli","ChineseAddress":"臺東縣卑南鄉山里路108號","EnglishAddress":"No.108, Shanli, Beinan Township, Taitung County , Taiwan (R.O.C.)","Telephone":"089-572370","gps":"22.862046,121.138031"},{"Station_Code_4":1632,"Station_Name":"臺東","Station_EName":"Taitung","Station_Code_3":4,"WebsiteName":"臺東站","EnglishName":"Taitung","ChineseAddress":"臺東市岩灣路101巷598號","EnglishAddress":"No.598, Ln. 101, Yanwan Rd., Taitung City, Taitung County , Taiwan (R.O.C.)","Telephone":"089-229687","gps":"22.793711,121.123175"},{"Station_Code_4":1703,"Station_Name":"永樂","Station_EName":"Yongle","Station_Code_3":64,"WebsiteName":"永樂站","EnglishName":"Yongle","ChineseAddress":"宜蘭縣蘇澳鎮永樂里圳頭路60號","EnglishAddress":"No.60, Zuntou Rd., Su’ao Township, Yilan County , Taiwan (R.O.C.)","Telephone":"03-9961889","gps":"24.568417,121.844564"},{"Station_Code_4":1704,"Station_Name":"東澳","Station_EName":"Dongao","Station_Code_3":63,"WebsiteName":"東澳站","EnglishName":"Dongao","ChineseAddress":"宜蘭縣南澳鄉東岳村1號","EnglishAddress":"No.1 , Dongyue County , Nan’ao Township, Yilan County , Taiwan (R.O.C.)","Telephone":"03-9986053","gps":"24.518221,121.830683"},{"Station_Code_4":1705,"Station_Name":"南澳","Station_EName":"Nanao","Station_Code_3":62,"WebsiteName":"南澳站","EnglishName":"Nanao","ChineseAddress":"宜蘭縣蘇澳鎮南強里大通路22號","EnglishAddress":"No.22, Datong Rd., Su’ao Township, Yilan County , Taiwan (R.O.C.)","Telephone":"03-9981971","gps":"24.463396,121.800926"},{"Station_Code_4":1706,"Station_Name":"武塔","Station_EName":"Wuta","Station_Code_3":60,"WebsiteName":"武塔站","EnglishName":"Wuta","ChineseAddress":"宜蘭縣南澳鄉武塔村新溪路18號","EnglishAddress":"No.18, Xinxi Rd., Nan’ao Township, Yilan County , Taiwan (R.O.C.)","Telephone":"03-9981971","gps":"24.448674,121.776037"},{"Station_Code_4":1708,"Station_Name":"漢本","Station_EName":"Hanben","Station_Code_3":58,"WebsiteName":"漢本站","EnglishName":"Hanben","ChineseAddress":"宜蘭縣南澳鄉澳花村蘇花路1段56號","EnglishAddress":"No.56, Sec. 1, Suhua Rd., Nan’ao Township, Yilan County , Taiwan (R.O.C.)","Telephone":"03-9985238","gps":"24.335428,121.768355"},{"Station_Code_4":1709,"Station_Name":"和平","Station_EName":"Heping","Station_Code_3":57,"WebsiteName":"和平站","EnglishName":"Heping","ChineseAddress":"花蓮縣秀林鄉和平村276號","EnglishAddress":"No.276, Heping, Xiulin Township, Hualien County , Taiwan (R.O.C.)","Telephone":"03-8681009","gps":"24.298296,121.753346"},{"Station_Code_4":1710,"Station_Name":"和仁","Station_EName":"Heren","Station_Code_3":56,"WebsiteName":"和仁站","EnglishName":"Heren","ChineseAddress":"花蓮縣秀林鄉和仁路71號","EnglishAddress":"No.71, Heren, Xiulin Township, Hualien County , Taiwan (R.O.C.)","Telephone":"03-8681221","gps":"24.242199,121.711749"},{"Station_Code_4":1711,"Station_Name":"崇德","Station_EName":"Chongde","Station_Code_3":55,"WebsiteName":"崇德站","EnglishName":"Chongde","ChineseAddress":"花蓮縣秀林鄉海濱路96號","EnglishAddress":"No.96, Haibin, Xiulin Township, Hualien County , Taiwan (R.O.C.)","Telephone":"03-8621365","gps":"24.172116,121.655498"},{"Station_Code_4":1712,"Station_Name":"新城","Station_EName":"Xincheng","Station_Code_3":54,"WebsiteName":"新城站","EnglishName":"Xincheng","ChineseAddress":"花蓮縣新城鄉新城村新興1路73號","EnglishAddress":"No.73, Xinxing 1st Rd., Xincheng Township, Hualien County , Taiwan (R.O.C.)","Telephone":"03-8611237","gps":"24.127524,121.640866"},{"Station_Code_4":1713,"Station_Name":"景美","Station_EName":"Jingmei","Station_Code_3":53,"WebsiteName":"景美站","EnglishName":"Jingmei","ChineseAddress":"花蓮縣秀林鄉加灣178-1號","EnglishAddress":"No.178-1, Jiawan, Xiulin Township, Hualien County , Taiwan (R.O.C.)","Telephone":"03-8611237","gps":"24.090317,121.610786"},{"Station_Code_4":1714,"Station_Name":"北埔","Station_EName":"Beipu","Station_Code_3":52,"WebsiteName":"北埔站","EnglishName":"Beipu","ChineseAddress":"花蓮縣新城鄉自強街113號","EnglishAddress":"No.113, Ziqiang St., Xincheng Township, Hualien County , Taiwan (R.O.C.)","Telephone":"03-8263809","gps":"24.032533,121.601671"},{"Station_Code_4":1715,"Station_Name":"花蓮","Station_EName":"Hualien","Station_Code_3":51,"WebsiteName":"花蓮站","EnglishName":"Hualien","ChineseAddress":"花蓮市國聯一路100號","EnglishAddress":"No.100, Guolian 1st Rd., Hualien City, Hualien County , Taiwan (R.O.C.)","Telephone":"03-8355941","gps":"23.992868,121.600993"},{"Station_Code_4":1006,"Station_Name":"南港","Station_EName":"Nangang","Station_Code_3":97,"WebsiteName":"南港站","EnglishName":"Nangang","ChineseAddress":"臺北市南港區南港路1段313號","EnglishAddress":"No.313, Sec. 1, Nangang Rd., Nangang Dist., Taipei City , Taiwan (R.O.C.)","Telephone":"02-27838645","gps":"25.05314,121.607019"},{"Station_Code_4":1007,"Station_Name":"松山","Station_EName":"Songshan","Station_Code_3":98,"WebsiteName":"松山站","EnglishName":"Songshan","ChineseAddress":"臺北市信義區永吉里松山路11號","EnglishAddress":"No.11, Songshan Rd., Xinyi Dist., Taipei City , Taiwan (R.O.C.)","Telephone":"02-27673819","gps":"25.04933,121.577965"},{"Station_Code_4":1008,"Station_Name":"臺北","Station_EName":"Taipei","Station_Code_3":100,"WebsiteName":"臺北站","EnglishName":"Taipei","ChineseAddress":"臺北市中正區黎明里北平西路3號","EnglishAddress":"No.3, Beiping W. Rd., Zhongzheng Dist., Taipei City , Taiwan (R.O.C.)","Telephone":"02-23713558、02-23111024","gps":"25.047503,121.517047"},{"Station_Code_4":1009,"Station_Name":"萬華","Station_EName":"Wanhua","Station_Code_3":101,"WebsiteName":"萬華站","EnglishName":"Wanhua","ChineseAddress":"臺北市萬華區富福里康定路382號","EnglishAddress":"No., Kangding Rd., Wanhua Dist., Taipei City 108, Taiwan (R.O.C.)","Telephone":"02-23020481","gps":"25.03335,121.500331"},{"Station_Code_4":1011,"Station_Name":"板橋","Station_EName":"Banqiao","Station_Code_3":102,"WebsiteName":"板橋站","EnglishName":"Banqiao","ChineseAddress":"新北市板橋區縣民大道2段7號","EnglishAddress":"No.7, Sec. 2, Xianmin Blvd., Banqiao Dist., New Taipei City , Taiwan (R.O.C.)","Telephone":"02-89691036","gps":"25.014399, 121.463497"},{"Station_Code_4":1032,"Station_Name":"浮洲","Station_EName":"Fuzhou","Station_Code_3":264,"WebsiteName":"浮洲站","EnglishName":"Fuzhou","ChineseAddress":"新北市板橋區僑中二街156號","EnglishAddress":"No.156, Qiaozhong 2nd St., Banqiao Dist., New Taipei City , Taiwan (R.O.C.)","Telephone":"02-23815226#4665","gps":"25.004184,121.444649"},{"Station_Code_4":1012,"Station_Name":"樹林","Station_EName":"Shulin","Station_Code_3":103,"WebsiteName":"樹林站","EnglishName":"Shulin","ChineseAddress":"新北市樹林區樹北里鎮前街112號","EnglishAddress":"No.112, Zhenqian St., Shulin Dist., New Taipei City , Taiwan (R.O.C.)","Telephone":"02-26812052","gps":"24.991348,121.424564"},{"Station_Code_4":1013,"Station_Name":"山佳","Station_EName":"Shanjia","Station_Code_3":104,"WebsiteName":"山佳站","EnglishName":"Shanjia","ChineseAddress":"新北市樹林區中山里中山路3段108號","EnglishAddress":"No.108, Sec. 3, Zhongshan Rd., Shulin Dist., New Taipei City , Taiwan (R.O.C.)","Telephone":"02-26808874","gps":"24.972482,121.392657"},{"Station_Code_4":1014,"Station_Name":"鶯歌","Station_EName":"Yingge","Station_Code_3":105,"WebsiteName":"鶯歌站","EnglishName":"Yingge","ChineseAddress":"新北市鶯歌區東鶯里文化路68-1號","EnglishAddress":"No.68-1, Wenhua Rd., Yingge Dist., New Taipei City , Taiwan (R.O.C.)","Telephone":"02-26792004","gps":"24.954532,121.355125"},{"Station_Code_4":1811,"Station_Name":"石城","Station_EName":"Shicheng","Station_Code_3":82,"WebsiteName":"石城站","EnglishName":"Shicheng","ChineseAddress":"宜蘭縣頭城鎮石城里濱海路7段230號","EnglishAddress":"No.230, Sec. 7, Binhai Rd., Toucheng Township, Yilan County , Taiwan (R.O.C.)","Telephone":"03-9771429","gps":"24.978334,121.945191"},{"Station_Code_4":1812,"Station_Name":"大里","Station_EName":"Dali","Station_Code_3":81,"WebsiteName":"大里站","EnglishName":"Dali","ChineseAddress":"宜蘭縣頭城鎮大里里濱海路6段326號","EnglishAddress":"No.326, Sec. 6, Binhai Rd., Toucheng Township, Yilan County , Taiwan (R.O.C.)","Telephone":"03-9781171","gps":"24.966799,121.922496"},{"Station_Code_4":1813,"Station_Name":"大溪","Station_EName":"Daxi","Station_Code_3":80,"WebsiteName":"大溪站","EnglishName":"Daxi","ChineseAddress":"宜蘭縣頭城鎮大溪里濱海路5段63號","EnglishAddress":"No.63, Sec. 5, Binhai Rd., Toucheng Township, Yilan County , Taiwan (R.O.C.)","Telephone":"03-9771429","gps":"24.938423,121.889873"},{"Station_Code_4":1814,"Station_Name":"龜山","Station_EName":"Guishan","Station_Code_3":79,"WebsiteName":"龜山站","EnglishName":"Guishan","ChineseAddress":"宜蘭縣頭城鎮更新里濱海路3段261號","EnglishAddress":"No.261, Sec. 3, Binhai Rd., Toucheng Township, Yilan County , Taiwan (R.O.C.)","Telephone":"03-9770351","gps":"24.904818,121.868878"},{"Station_Code_4":1815,"Station_Name":"外澳","Station_EName":"Waiao","Station_Code_3":78,"WebsiteName":"外澳站","EnglishName":"Waiao","ChineseAddress":"宜蘭縣頭城鎮外澳里濱海路2段217號","EnglishAddress":"No.217, Sec. 2, Binhai Rd., Toucheng Township, Yilan County , Taiwan (R.O.C.)","Telephone":"03-9771429","gps":"24.883703,121.845758"},{"Station_Code_4":1816,"Station_Name":"頭城","Station_EName":"Toucheng","Station_Code_3":77,"WebsiteName":"頭城站","EnglishName":"Toucheng","ChineseAddress":"宜蘭縣頭城鎮城北里纘祥路59號","EnglishAddress":"No.59, Zuanxiang Rd., Toucheng Township, Yilan County , Taiwan (R.O.C.)","Telephone":"03-9771429","gps":"24.858976,121.822556"},{"Station_Code_4":1817,"Station_Name":"頂埔","Station_EName":"Dingpu","Station_Code_3":76,"WebsiteName":"頂埔站","EnglishName":"Dingpu","ChineseAddress":"宜蘭縣頭城鎮下埔里下埔路4-8號","EnglishAddress":"No.4-8, Xiapu Rd., Toucheng Township, Yilan County , Taiwan (R.O.C.)","Telephone":"03-9886940","gps":"24.843998,121.809207"},{"Station_Code_4":1818,"Station_Name":"礁溪","Station_EName":"Jiaoxi","Station_Code_3":75,"WebsiteName":"礁溪站","EnglishName":"Jiaoxi","ChineseAddress":"宜蘭縣礁溪鄉德陽村溫泉路1號","EnglishAddress":"No.1, Wenquan Rd., Jiaoxi Township, Yilan County , Taiwan (R.O.C.)","Telephone":"03-9886940","gps":"24.827034,121.775354"},{"Station_Code_4":1819,"Station_Name":"四城","Station_EName":"Sicheng","Station_Code_3":74,"WebsiteName":"四城站","EnglishName":"Sicheng","ChineseAddress":"宜蘭縣礁溪鄉吳沙村站前路24號","EnglishAddress":"No.24, Zhanqian Rd., Jiaoxi Township, Yilan County , Taiwan (R.O.C.)","Telephone":"03-9282449","gps":"24.786802,121.762727"},{"Station_Code_4":1820,"Station_Name":"宜蘭","Station_EName":"Yilan","Station_Code_3":73,"WebsiteName":"宜蘭站","EnglishName":"Yilan","ChineseAddress":"宜蘭縣宜蘭市和睦里光復路1號","EnglishAddress":"No.1, Guangfu Rd., Yilan City, Yilan County , Taiwan (R.O.C.)","Telephone":"03-9323801","gps":"24.754512,121.758253"},{"Station_Code_4":1821,"Station_Name":"二結","Station_EName":"Erjie","Station_Code_3":72,"WebsiteName":"二結站","EnglishName":"Erjie","ChineseAddress":"宜蘭縣五結鄉三興村復興中路37號","EnglishAddress":"No.37, Fuxing Central Rd., Wujie Township, Yilan County , Taiwan (R.O.C.)","Telephone":"03-9650304","gps":"24.705267,121.774131"},{"Station_Code_4":1822,"Station_Name":"中里","Station_EName":"Zhongli","Station_Code_3":71,"WebsiteName":"中里站","EnglishName":"Zhongli","ChineseAddress":"宜蘭縣五結鄉台興路10號","EnglishAddress":"No.10, Taixing Rd., Wujie Township, Yilan County , Taiwan (R.O.C.)","Telephone":"03-9542117","gps":"24.694192,121.775163"},{"Station_Code_4":1823,"Station_Name":"羅東","Station_EName":"Luodong","Station_Code_3":70,"WebsiteName":"羅東站","EnglishName":"Luodong","ChineseAddress":"宜蘭縣羅東鎮大新里公正路2號","EnglishAddress":"No.2, Gongzheng Rd., Luodong Township, Yilan County , Taiwan (R.O.C.)","Telephone":"03-9542117","gps":"24.677929,121.774629"},{"Station_Code_4":1824,"Station_Name":"冬山","Station_EName":"Dongshan","Station_Code_3":69,"WebsiteName":"冬山站","EnglishName":"Dongshan","ChineseAddress":"宜蘭縣冬山鄉冬山村中正路1號","EnglishAddress":"No.1, Zhongzheng Rd., Dongshan Township, Yilan County , Taiwan (R.O.C.)","Telephone":"03-9594221","gps":"24.636726,121.792246"},{"Station_Code_4":1825,"Station_Name":"新馬","Station_EName":"Xinma","Station_Code_3":68,"WebsiteName":"新馬站","EnglishName":"Xinma","ChineseAddress":"宜蘭縣蘇澳鎮中山路2段322號","EnglishAddress":"No.322, Sec. 2, Zhongshan Rd., Su’ao Township, Yilan County , Taiwan (R.O.C.)","Telephone":"03-9961004","gps":"24.615395,121.822900"},{"Station_Code_4":1826,"Station_Name":"蘇澳新","Station_EName":"Suaoxin","Station_Code_3":67,"WebsiteName":"蘇澳新站","EnglishName":"Suaoxin","ChineseAddress":"宜蘭縣蘇澳鎮中山路2段238號之1","EnglishAddress":"No.238, Sec. 2, Zhongshan Rd., Su’ao Township, Yilan County , Taiwan (R.O.C.)","Telephone":"03-9961004","gps":"24.609024,121.827030"},{"Station_Code_4":1827,"Station_Name":"蘇澳","Station_EName":"Suao","Station_Code_3":66,"WebsiteName":"蘇澳站","EnglishName":"Suao","ChineseAddress":"宜蘭縣蘇澳鎮蘇南里太平路1號","EnglishAddress":"No.1, Taiping Rd., Su’ao Township, Yilan County , Taiwan (R.O.C.)","Telephone":"03-9962028","gps":"24.595181,121.851440"},{"Station_Code_4":1903,"Station_Name":"大華","Station_EName":"Dahua","Station_Code_3":231,"WebsiteName":"大華站","EnglishName":"Dahua","ChineseAddress":"新北市平溪區六分路12-1號","EnglishAddress":"No.12-1, Liufen, Pingxi Dist., New Taipei City , Taiwan (R.O.C.)","Telephone":"02-24972033","gps":"25.049758,121.797929"},{"Station_Code_4":1904,"Station_Name":"十分","Station_EName":"Shifen","Station_Code_3":232,"WebsiteName":"十分站","EnglishName":"Shifen","ChineseAddress":"新北市平溪區十分街51號","EnglishAddress":"No.51, Shifen St., Pingxi Dist., New Taipei City , Taiwan (R.O.C.)","Telephone":"02-24958307","gps":"25.040991,121.775229"},{"Station_Code_4":1905,"Station_Name":"望古","Station_EName":"Wanggu","Station_Code_3":233,"WebsiteName":"望古站","EnglishName":"Wanggu","ChineseAddress":"新北市平溪區(無站房)","EnglishAddress":"Pingxi Dist., New Taipei City , Taiwan (R.O.C.)（No Station House）","Telephone":"02-24972033","gps":"25.03454,121.763782"},{"Station_Code_4":1906,"Station_Name":"嶺腳","Station_EName":"Lingjiao","Station_Code_3":234,"WebsiteName":"嶺腳站","EnglishName":"Lingjiao","ChineseAddress":"新北市平溪區嶺腳街22號","EnglishAddress":"No.22, Lingjiao St., Pingxi Dist., New Taipei City, Taiwan (R.O.C.)","Telephone":"02-24972033","gps":"25.030138, 121.748102"},{"Station_Code_4":1907,"Station_Name":"平溪","Station_EName":"Pingxi","Station_Code_3":235,"WebsiteName":"平溪站","EnglishName":"Pingxi","ChineseAddress":"新北市平溪區中華街12號","EnglishAddress":"No.12, Zhonghua St., Pingxi Dist., New Taipei City 226, Taiwan (R.O.C.)","Telephone":"02-24972033","gps":"25.025633,121.739984"},{"Station_Code_4":1908,"Station_Name":"菁桐","Station_EName":"Jingtong","Station_Code_3":236,"WebsiteName":"菁桐站","EnglishName":"Jingtong","ChineseAddress":"新北市平溪區菁桐街52號","EnglishAddress":"No.52, Jingtong St., Pingxi Dist., New Taipei City , Taiwan (R.O.C.)","Telephone":"02-24972033","gps":"25.023918, 121.723649"},{"Station_Code_4":2203,"Station_Name":"竹中","Station_EName":"Zhuzhong","Station_Code_3":241,"WebsiteName":"竹中站","EnglishName":"Zhuzhong","ChineseAddress":"新竹縣頭重里竹中路145號","EnglishAddress":"No.145, Zhuzhong Rd., Zhudong Township, Hsinchu County , Taiwan (R.O.C.)","Telephone":"03-5962042","gps":"24.781358,121.031306"},{"Station_Code_4":2204,"Station_Name":"上員","Station_EName":"Shangyuan","Station_Code_3":242,"WebsiteName":"上員站","EnglishName":"Shangyuan","ChineseAddress":"新竹縣竹東鎮上員里(無站房)","EnglishAddress":"Zhudong Township, Hsinchu County , Taiwan (R.O.C.)（No Station House）","Telephone":"03-5962042","gps":"24.77789,121.055725"},{"Station_Code_4":2205,"Station_Name":"竹東","Station_EName":"Zhudong","Station_Code_3":243,"WebsiteName":"竹東站","EnglishName":"Zhudong","ChineseAddress":"新竹縣竹東鎮雞林里東林路196號","EnglishAddress":"No.196, Donglin Rd., Zhudong Township, Hsinchu County , Taiwan (R.O.C.)","Telephone":"03-5962042","gps":"24.738257,121.0949"},{"Station_Code_4":2206,"Station_Name":"橫山","Station_EName":"Hengshan","Station_Code_3":244,"WebsiteName":"橫山站","EnglishName":"Hengshan","ChineseAddress":"新竹縣橫山鄉橫山村橫山路97號(無站房)","EnglishAddress":"No.97, Hengshan Rd. , Hengshan Township, Hsinchu County , Taiwan (R.O.C.)","Telephone":"03-5962042","gps":"24.72056,121.11645"},{"Station_Code_4":2207,"Station_Name":"九讚頭","Station_EName":"Jiuzantou","Station_Code_3":245,"WebsiteName":"九讚頭站","EnglishName":"Jiuzantou","ChineseAddress":"新竹縣橫山鄉中豐路2段286巷29號","EnglishAddress":"No.29, Ln. 286, Sec. 2, Zhongfeng Rd., Hengshan Township, Hsinchu County 312, Taiwan (R.O.C.)","Telephone":"03-5962042","gps":"24.720599,121.13602"},{"Station_Code_4":2208,"Station_Name":"合興","Station_EName":"Hexing","Station_Code_3":246,"WebsiteName":"合興站","EnglishName":"Hexing","ChineseAddress":"新竹縣橫山鄉中山街1段17號","EnglishAddress":"No.17, Sec. 1, Zhongshan St., Hengshan Township, Hsinchu County 312, Taiwan (R.O.C.)","Telephone":"03-5962042","gps":"24.716746,121.154403"},{"Station_Code_4":2209,"Station_Name":"富貴","Station_EName":"Fugui","Station_Code_3":247,"WebsiteName":"富貴站","EnglishName":"Fugui","ChineseAddress":"新竹縣橫山鄉(無站房)","EnglishAddress":"Hengshan Township, Hsinchu County , Taiwan (R.O.C.)（No Station House）","Telephone":"03-5962042","gps":"24.715559,121.167377"},{"Station_Code_4":2210,"Station_Name":"內灣","Station_EName":"Neiwan","Station_Code_3":248,"WebsiteName":"內灣站","EnglishName":"Neiwan","ChineseAddress":"新竹縣橫山鄉中正路6號","EnglishAddress":"No.6, Zhongzheng Rd., Hengshan Township, Hsinchu County , Taiwan (R.O.C.)","Telephone":"03-5962042","gps":"24.705317,121.182325"},{"Station_Code_4":2211,"Station_Name":"榮華","Station_EName":"Ronghua","Station_Code_3":249,"WebsiteName":"榮華站","EnglishName":"Ronghua","ChineseAddress":"新竹縣竹東鎮仁愛里(無站房)","EnglishAddress":"Zhudong Township, Hsinchu County , Taiwan (R.O.C.)（No Station House）","Telephone":"03-5962042","gps":"24.74839,121.083399"},{"Station_Code_4":2212,"Station_Name":"千甲","Station_EName":"Qianjia","Station_Code_3":238,"WebsiteName":"千甲站","EnglishName":"Qianjia","ChineseAddress":"新竹市水源里千甲路142號","EnglishAddress":"No.142, Qianjia Rd., East Dist., Hsinchu City , Taiwan (R.O.C.)","Telephone":"03-5237441","gps":"24.806662,121.003273"},{"Station_Code_4":2213,"Station_Name":"新莊","Station_EName":"Xinzhuang","Station_Code_3":239,"WebsiteName":"新莊站","EnglishName":"Xinzhuang","ChineseAddress":"新竹市新莊里關東路310號","EnglishAddress":"No.310, Guandong Rd., East Dist., Hsinchu City , Taiwan (R.O.C.)","Telephone":"03-5237441","gps":"24.788176,121.022122"},{"Station_Code_4":2214,"Station_Name":"六家","Station_EName":"Liujia","Station_Code_3":240,"WebsiteName":"六家站","EnglishName":"Liujia","ChineseAddress":"新竹縣竹北市復興三路2段229號","EnglishAddress":"No.229, Sec. 2, Fuxing 3rd Rd., Zhubei City, Hsinchu County , Taiwan (R.O.C.)","Telephone":"03-5962042","gps":"24.807655,121.039417"},{"Station_Code_4":2702,"Station_Name":"源泉","Station_EName":"Yuanquan","Station_Code_3":251,"WebsiteName":"源泉站","EnglishName":"Yuanquan","ChineseAddress":"彰化縣二水鄉合興村英義路(無站房)","EnglishAddress":"Yingyi Rd., Ershui Township, Changhua County , Taiwan (R.O.C.)（No Station House）","Telephone":"04-8792027","gps":"23.798445,120.642034"},{"Station_Code_4":2703,"Station_Name":"濁水","Station_EName":"Zhuoshui","Station_Code_3":252,"WebsiteName":"濁水站","EnglishName":"Zhuoshui","ChineseAddress":"南投縣名間鄉濁水村車站路53號","EnglishAddress":"No.53, Chezhan Rd., Mingjian Township, Nantou County , Taiwan (R.O.C.)","Telephone":"049-2735850","gps":"23.834666,120.704720"},{"Station_Code_4":2704,"Station_Name":"龍泉","Station_EName":"Longquan","Station_Code_3":253,"WebsiteName":"龍泉站","EnglishName":"Longquan","ChineseAddress":"南投縣集集鎮隘寮村(無站房)","EnglishAddress":"Jiji Township, Nantou County , Taiwan (R.O.C.)（No Station House）","Telephone":"04-8792027","gps":"23.835188,120.750404"},{"Station_Code_4":2705,"Station_Name":"集集","Station_EName":"Jiji","Station_Code_3":254,"WebsiteName":"集集站","EnglishName":"Jiji","ChineseAddress":"南投縣集集鎮民生路75號","EnglishAddress":"No.75, Minsheng Rd., Jiji Township, Nantou County , Taiwan (R.O.C.)","Telephone":"049-2762546","gps":"23.826451,120.784891"},{"Station_Code_4":2706,"Station_Name":"水里","Station_EName":"Shuili","Station_Code_3":255,"WebsiteName":"水里站","EnglishName":"Shuili","ChineseAddress":"南投縣水里鄉民生路442號","EnglishAddress":"No.442, Minsheng Rd., Shuili Township, Nantou County , Taiwan (R.O.C.)","Telephone":"049-2770015","gps":"23.818456,120.853323"},{"Station_Code_4":2707,"Station_Name":"車埕","Station_EName":"Checheng","Station_Code_3":256,"WebsiteName":"車埕站","EnglishName":"Checheng","ChineseAddress":"南投縣水里鄉車埕村民權巷2號","EnglishAddress":"No.2, Minquan Ln., Shuili Township, Nantou County , Taiwan (R.O.C.)","Telephone":"049-2774749","gps":"23.832637,120.865745"},{"Station_Code_4":3202,"Station_Name":"花蓮港","Station_EName":"hualien Port","Station_Code_3":260,"WebsiteName":"花蓮港站","EnglishName":"hualien Port","ChineseAddress":"花蓮市港口街2號","EnglishAddress":"No.2, Gangkou Rd., Hualien City, Hualien County , Taiwan (R.O.C.)","Telephone":"03-8222468","gps":"23.994013, 121.636083"},{"Station_Code_4":4102,"Station_Name":"樹調","Station_EName":"ShuDiao","Station_Code_3":"","WebsiteName":"樹調站","EnglishName":"ShuDiao","ChineseAddress":"","EnglishAddress":"","Telephone":"","gps":""},{"Station_Code_4":5101,"Station_Name":"長榮大學","Station_EName":"CJCU","Station_Code_3":283,"WebsiteName":"長榮大學站","EnglishName":"CJCU","ChineseAddress":"臺南市歸仁區長榮一段200巷72弄126號","EnglishAddress":"No.126, Aly. 72, Ln. 200, Sec. 1, Changrong Rd., Guiren Dist., Tainan City , Taiwan (R.O.C.)","Telephone":"06-2782615","gps":"22.907187, 120.272176"},{"Station_Code_4":5102,"Station_Name":"沙崙","Station_EName":"Shalun","Station_Code_3":284,"WebsiteName":"沙崙站","EnglishName":"Shalun","ChineseAddress":"臺南市歸仁區沙崙里9鄰歸仁大道102號","EnglishAddress":"No.102, Guiren Blvd., Guiren Dist., Tainan City , Taiwan (R.O.C.)","Telephone":"06-3032686","gps":"22.923953, 120.286371"},{"Station_Code_4":1034,"Station_Name":"南樹林","Station_EName":"South Shulin","Station_Code_3":265,"WebsiteName":"南樹林站","EnglishName":"South Shulin","ChineseAddress":"新北市樹林區中山路二段230號","EnglishAddress":"No.230, Sec. 2, Zhongshan Rd., Shulin Dist., New Taipei City 23846, Taiwan (R.O.C.)","Telephone":"02-26812052","gps":"24.980485, 121.408796"},{"Station_Code_4":1026,"Station_Name":"香山","Station_EName":"Xiangshan","Station_Code_3":116,"WebsiteName":"香山站","EnglishName":"Xiangshan","ChineseAddress":"新竹市朝山里中華路5段347巷2弄27號","EnglishAddress":"No.27, Aly. 2, Ln. 347, Sec. 5, Zhonghua Rd., Xiangshan Dist., Hsinchu City , Taiwan (R.O.C.)","Telephone":"03-5237441","gps":"24.763121,120.91389"},{"Station_Code_4":2003,"Station_Name":"八斗子","Station_EName":"Badouzi","Station_Code_3":292,"WebsiteName":"八斗子站","EnglishName":"Badouzi","ChineseAddress":"無","EnglishAddress":"none","Telephone":"無","gps":"25.135392, 121.803199"},{"Station_Code_4":"1036","Station_Name":"新富","Station_EName":"Xinfu","Station_Code_3":270,"WebsiteName":"新富站","EnglishName":"Xinfu","ChineseAddress":"無","EnglishAddress":"none","Telephone":"無","gps":"24.931239,121.0665116"}]

/***/ }),

/***/ "gvMo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["train", "fares"],
  data: function data() {
    return {};
  },

  methods: {
    /**
     * 取得票價
     */
    getFare: function getFare(code) {
      return this.fares[code].price;
    }
  }
});

/***/ }),

/***/ "hV6e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__static_trainclasses_json__ = __webpack_require__("+2Sp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__static_trainclasses_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__static_trainclasses_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__static_trainTypeMaps_json__ = __webpack_require__("ZX8f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__static_trainTypeMaps_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__static_trainTypeMaps_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TrainItem_vue__ = __webpack_require__("FVg3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TrainItemMobile_vue__ = __webpack_require__("UGwd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SearchTips_vue__ = __webpack_require__("Gvql");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SearchError_vue__ = __webpack_require__("wtKx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Briefing_vue__ = __webpack_require__("7+I5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__History_vue__ = __webpack_require__("KlNx");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      input: {
        keyword: this.$ls.get("input.keyword", null)
      },
      sdStations: this.$ls.get("sdStations", {
        startStation: null,
        destStation: null
      }),
      timeTables: this.$ls.get("timeTables", false),
      delayInfo: [],
      trainClassMap: this.$ls.get("trainClassMap", {}),
      hideDepartured: true,
      fares: null,
      status: null,
      keywordArray: [],
      orderByField: this.$ls.get("orderByField", {
        field: "StopTimes[0].DepartureTime",
        order: "asc"
      }),
      orderByFieldClass: {},
      trainsResponse: null,
      query: {},
      history: this.$ls.get("input.history", [])
    };
  },

  components: {
    TrainItem: __WEBPACK_IMPORTED_MODULE_2__TrainItem_vue__["a" /* default */],
    TrainItemMobile: __WEBPACK_IMPORTED_MODULE_3__TrainItemMobile_vue__["a" /* default */],
    SearchTips: __WEBPACK_IMPORTED_MODULE_4__SearchTips_vue__["a" /* default */],
    SearchError: __WEBPACK_IMPORTED_MODULE_5__SearchError_vue__["a" /* default */],
    Briefing: __WEBPACK_IMPORTED_MODULE_6__Briefing_vue__["a" /* default */],
    History: __WEBPACK_IMPORTED_MODULE_7__History_vue__["a" /* default */]
  },
  methods: {
    /**
     * 導航到列車詳細資訊
     */
    toTrainDetail: function toTrainDetail(train) {
      this.$router.push({
        name: "Timetable.train",
        params: {
          train: train.TrainInfo.TrainNo,
          date: this.query.date
        }
      });
    },
    /**
     * Test if user wants to query by TrainNo
     */
    retTrainNo: function retTrainNo() {
      if (this.keywordArray.length <= 2 && /^\d{2,4}$/.test(this.keywordArray[0]) && !/^\d{1,}$/.test(this.keywordArray[1])) {
        this.period = this.searchDate(this.keywordArray[1]);

        this.$ls.set("input.keyword", this.keyword);

        this.$router.push({
          name: "Timetable.train",
          params: {
            train: this.keywordArray[0],
            date: this.query.date
          }
        });
      }
    },
    /**
     * Search Handler
     */
    search: function search() {
      var _this = this;

      var keyword = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (_.isNotNull(keyword)) {
        this.input.keyword = keyword;
      }

      if (_.isNull(this.input.keyword)) {
        return false;
      }

      this.setResultParams();

      this.status = "loading";
      /**
       * Get Daily TimeTable.
       */
      this.searchTimetableBetweenOriginAndDestination(this.input.keyword).then(function (response) {
        _this.trainsResponse = response.data.payload;
        _this.query = response.data.query;
        _this.fares = response.data.fares;

        _this.clearFilter();

        if (_.isNotNull(response.data.query.trainType)) {
          _this.setTrainClassMap(response.data.query.trainType);
        }

        var expireMs = _this.moment().add(1, "minutes").diff();

        _this.$ls.set("search.responses", response.data, expireMs);
        _this.$ls.set("input.keyword", _this.input.keyword, expireMs);

        _this.pushHistory(_this.input.keyword);

        _this.status = true;
      }, function (error) {
        console.log(error);

        _this.status = false;
      });
    },
    pushHistory: function pushHistory(keyword) {
      var history = this.history;

      history = _.reverse(history);
      history.push(keyword);

      var result = _.chain(history).reverse().uniq().take(5).value();

      this.history = result;
      this.$ls.set("input.history", result);
    },

    /**
     * Return the train fare by searching request result
     */
    trainFare: function trainFare(c) {
      if (!c || !this.fares) return "N/A";

      var classFare = __WEBPACK_IMPORTED_MODULE_0__static_trainclasses_json___default.a.find(function (trainclass) {
        return trainclass.classNo == c;
      }).classFare;

      return "$" + this.fares.find(function (fare) {
        return fare.TicketType == classFare;
      }).Price;
    },

    /**
     * Empty the search field and set focus
     */
    searchEmpty: function searchEmpty() {
      this.input.keyword = null;
      this.$refs.keyword.focus();

      this.trainsResponse = null;
      this.fares = null;

      this.orderByField = {
        field: "OriginStopTime.DepartureTime",
        order: "asc"
      };

      this.$router.replace({
        query: null
      });

      // Clear all localStorage result
      this.$ls.clear();
    },

    /**
     * Remove the trainClassMap filter in order to show all the trains.
     */
    clearFilter: function clearFilter() {
      this.trainClassMap = {};
      this.$ls.set("trainClassMap", {});
    },

    /**
     * Set TrainClassMap after calling this.searchTrainClass.
     * Return empty object if find no result.
     */
    setTrainClassMap: function setTrainClassMap(c) {
      // 加入 description (如 tc: 自強號)
      this.trainClassMap = _.chain(__WEBPACK_IMPORTED_MODULE_1__static_trainTypeMaps_json___default.a).get(c).value();
      // Set trainClassMap to localStorage
      this.$ls.set("trainClassMap", this.trainClassMap);
    },

    /**
     * Set Order By
     */
    setOrderBy: function setOrderBy(f) {
      // If it's same field, toggle `asc` or `desc`
      if (f == this.orderByField.field) {
        this.orderByField.order = this.orderByField.order == "asc" ? "desc" : "asc";
      }

      // Otherwise change field
      this.orderByField.field = f;

      // Set result to Query params.
      this.setResultParams();

      // Set orderByField to localStorage
      this.$ls.set("orderByField", this.orderByField);
    },

    /**
     * Set result to Query params in order to get same query next time.
     */
    setResultParams: function setResultParams() {
      this.$router.push({
        query: {
          k: this.input.keyword,
          f: this.orderByField.field,
          o: this.orderByField.order
        }
      });
    },

    /**
     * Return order by fields' icon class name
     */
    orderByClass: function orderByClass(f) {
      return f == this.orderByField.field && (this.orderByField.order == "asc" ? "red ascending" : "red descending");
    }
  },
  computed: {
    /**
     * Check if it's qualify to show delay information
     */
    delay: function delay() {
      return !!this.delayInfo.length && this.period.today || false;
    },
    trains: function trains() {
      var _this2 = this;

      var trains = this.lcollect(this.trainsResponse);

      if (trains.isNull().value()) {
        return false;
      }

      if (_.isNotEmpty(this.trainClassMap)) {
        trains = trains.filter(function (train) {
          return _.includes(_this2.trainClassMap.includes, _.get(train, "TrainInfo.TrainTypeCode", 0));
        });
      }

      return trains.orderBy(this.orderByField.field, this.orderByField.order).value();
    }
  },
  mounted: function mounted() {
    var responses = this.$ls.get("search.responses");

    if (!_.isNull(responses)) {
      this.trainsResponse = responses.payload;
      this.fares = responses.fares;
      this.query = responses.query;
    }

    if (this.$route.query.f) {
      this.orderByField.field = this.$route.query.f;
    }

    if (this.$route.query.o) {
      this.orderByField.order = this.$route.query.o;
    }

    if (this.$route.query.k) {
      this.input.keyword = this.$route.query.k;
      this.search();
    }

    this.$refs.keyword.focus();
  }
});

/***/ }),

/***/ "idTU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["query", "trains", "fares", "trainClassMap", "trainsResponseCount"]
});

/***/ }),

/***/ "n4jg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui red message"},[_c('div',{staticClass:"header"},[_vm._v("查無此站或格式錯誤")]),_vm._v(" "),_c('p',[_vm._v("\n    請輸入起迄站、時間、車種即可。「中壢 新竹」「新左營 鳳山 週四」「高雄 嘉義 1/18 自強號」。可用 1/18、1月18日、1-18、星期四、週四。可以輸入車種以過濾「台北 花蓮 傾斜式」「中壢 台北 對號」。\n    "),_c('router-link',{attrs:{"to":{
          name: 'About'
      }}},[_vm._v("詳細說明")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "nUGc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui fluid card pointer"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"ui grid"},[_c('div',{staticClass:"twelve wide column"},[_c('h3',{staticClass:"ui header",class:_vm.trainTypeColor(_vm.train.TrainInfo.TrainTypeCode)},[_vm._v("\n          "+_vm._s(_vm.train.TrainInfo.TrainTypeName.Zh_tw)+"\n          "),_c('div',{staticClass:"sub header"},[_vm._v(_vm._s(_vm.train.TrainInfo.TrainNo))])])]),_vm._v(" "),_c('div',{staticClass:"four wide column"},[_c('div',{staticClass:"right floated ui"},[(_vm.train.TrainInfo.TripLine != 0)?_c('div',{staticClass:"ui circular basic label",class:[_vm.tripLine(_vm.train.TrainInfo.TripLine, true)]},[_vm._v(_vm._s(_vm.tripLine(_vm.train.TrainInfo.TripLine)))]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"description"},[_c('div',{staticClass:"ui grid"},[_c('div',{staticClass:"five wide column departure-time"},[_vm._v(_vm._s(_vm.train.TrainInfo.DepartureTime))]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"six wide column"},[_vm._v("\n          "+_vm._s(_vm.train.TrainInfo.EndingStationName.Zh_tw)+"\n          "+_vm._s(_vm.train.TrainInfo.EndingStationName.En)+"\n        ")])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"one wide column"},[_c('i',{staticClass:"arrow right icon"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "pMZz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'hello',
  data: function data() {
    return {
      msg: 'Welcome to Your Vue.js App'
    };
  }
});

/***/ }),

/***/ "q901":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_About_vue__ = __webpack_require__("BBWr");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_750712ec_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_About_vue__ = __webpack_require__("xpqj");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_About_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_750712ec_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_About_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "qSdX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Hello_vue__ = __webpack_require__("pMZz");
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b54b11b0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Hello_vue__ = __webpack_require__("TaWI");
function injectStyle (ssrContext) {
  __webpack_require__("unId")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b54b11b0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Hello_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b54b11b0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Hello_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "r91A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Stations_vue__ = __webpack_require__("abwL");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c1fde14_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Stations_vue__ = __webpack_require__("JMZ3");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Stations_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c1fde14_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Stations_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "rlqe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',[_c('div',{staticClass:"ui grid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"sixteen wide column"},[_c('h3',{staticClass:"ui header",class:_vm.trainTypeColor(_vm.train.TrainInfo.TrainTypeCode)},[_vm._v("\n            "+_vm._s(_vm.train.TrainInfo.TrainTypeName.Zh_tw)+"\n            "),_c('h5',{staticClass:"ui right floated header"},[_c('div',{staticClass:"sub header"},[_vm._v(_vm._s(_vm.train.TrainInfo.TrainNo))])])])]),_vm._v(" "),_c('div',{staticClass:"sixteen wide column"},[_c('h5',{staticClass:"ui header"},[_c('div',{staticClass:"sub header"},[_vm._v("\n              "+_vm._s(_vm.train.TrainInfo.StartingStationName.Zh_tw)+"\n              "),_c('i',{staticClass:"arrow right icon inline-icon"}),_vm._v("\n              "+_vm._s(_vm.train.TrainInfo.EndingStationName.Zh_tw)+"\n            ")])])])])])]),_vm._v(" "),_c('td',{staticClass:"center aligned"},[(_vm.train.TrainInfo.TripLine)?_c('div',{staticClass:"ui circular basic label",class:[_vm.tripLine(_vm.train.TrainInfo.TripLine, true)]},[_vm._v(_vm._s(_vm.tripLine(_vm.train.TrainInfo.TripLine)))]):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"center aligned departure-time"},[_vm._v(_vm._s(_vm.train.StopTimes[0].DepartureTime))]),_vm._v(" "),_c('td',{staticClass:"center aligned"},[_c('h5',{staticClass:"ui trip icon header"},[_c('i',{staticClass:"arrow right icon"}),_vm._v(" "),_c('div',{staticClass:"sub header"},[_vm._v(_vm._s(_vm.timeDiff( _vm.train.StopTimes[0].DepartureTime, _vm.train.StopTimes[1].ArrivalTime).humanize))])])]),_vm._v(" "),_c('td',{staticClass:"center aligned"},[_vm._v(_vm._s(_vm.train.StopTimes[1].ArrivalTime))]),_vm._v(" "),_c('td',[_c('div',{staticClass:"ui basic grey horizontal medium label"},[_vm._v(_vm._s(_vm.train.StopTimes[1].StopSequence - _vm.train.StopTimes[0].StopSequence)+"站")]),_vm._v(" "),(_vm.train.TrainInfo.WheelChairFlag)?_c('div',{staticClass:"ui blue horizontal medium label"},[_vm._v("輪椅")]):_vm._e(),_vm._v(" "),(_vm.train.TrainInfo.BreastFeedFlag)?_c('div',{staticClass:"ui pink horizontal medium label"},[_vm._v("哺乳室")]):_vm._e(),_vm._v(" "),(_vm.train.TrainInfo.BikeFlag)?_c('div',{staticClass:"ui green horizontal medium label"},[_vm._v("自行車")]):_vm._e(),_vm._v(" "),(_vm.DMULabel(_vm.train.TrainInfo.Note.Zh_tw))?_c('div',{staticClass:"ui yellow horizontal medium label"},[_vm._v("柴聯")]):_vm._e(),_vm._v(" "),(_vm.overNightLabel(_vm.train.TrainInfo.OverNightStationID))?_c('div',{staticClass:"ui brown horizontal medium label"},[_vm._v("跨日")]):_vm._e(),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm._f("noteFormat")(_vm.train.TrainInfo.Note)))])]),_vm._v(" "),_c('td',[_vm._v(_vm._s("$ " + _vm.getFare(_vm.train.TrainInfo.TrainTypeCode)))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "tF+R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__static_stations_json__ = __webpack_require__("fUqv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__static_stations_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__static_stations_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__static_periods_json__ = __webpack_require__("3eAj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__static_periods_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__static_periods_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__static_triplines_json__ = __webpack_require__("1PUk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__static_triplines_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__static_triplines_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__static_trainclassmaps_json__ = __webpack_require__("BfgB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__static_trainclassmaps_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__static_trainclassmaps_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__static_trainclasses_json__ = __webpack_require__("+2Sp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__static_trainclasses_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__static_trainclasses_json__);







/* harmony default export */ __webpack_exports__["default"] = ({
  lcollect: function lcollect(items) {
    return _.chain(items);
  },

  /**
   * Transform `台` into `臺` in order to search the station.
   * return string with `臺`
   */
  taiTransform: function taiTransform(w) {
    return w.replace(/台/g, '臺') || '';
  },

  /* Replace whitespace more than 1, split into array
   * return keyword Array
   */
  strToArray: function strToArray(s) {
    return s.replace(/\s{1,}/ig, ' ').split(' ');
  },

  getStations: function getStations() {
    return axios.get("https://benyi.tw/trainfo-api/public/" + 'api/stations');
  },

  getStationDetail: function getStationDetail(stationNo, date) {

    var toBuild = _.pickBy({
      no: stationNo,
      date: date
    });

    var query = new URLSearchParams(toBuild).toString();

    return axios.get("https://benyi.tw/trainfo-api/public/" + 'api/station?' + query);
  },

  /**
   * Search Date
   */
  searchDate: function searchDate(d) {

    d = d || '';

    // Year Handling format
    var yearCondition = ['YYYY-M-D', 'YYYY年M月D日', 'YYYY/M/D'];
    // Month && Day only handling format
    var noYearCondition = ['M-D', 'M月D日', 'M/D', 'M月D'];

    function getToday() {
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()().format('YYYY-MM-DD');
    }
    // Get the weekday by given string
    function getDay(d) {
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()().isoWeekday(d);
    }
    // Check if the given condition matches the format of date
    // It's an alias of `moment.js`
    function isValidDate(param) {
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(d, param, true).isValid();
    }

    // Get the moment() instance by many ways
    var m = function () {

      // If matches the following format (下週一, 週三, 星期六, 禮拜天... etc...)
      if (d.match(/(下)?(週|星期|禮拜)(一|二|三|四|五|六|日|天)/)) {

        // Replace '禮拜' to '星期'
        d = d.replace('禮拜', '星期');

        // If contains `下` then stands for `NEXT`
        if (/^下/.test(d)) {
          // Remove `下` of the start of String, and add 1 week for the `next`.
          return getDay(d.replace(/下/g, '')).add(1, 'WEEK');
        }

        // Determine if the date is before today or not. If so, get the next weekday
        if (getDay(d).isBefore(getToday())) {
          return getDay(d).add(1, 'WEEK');
        }

        return getDay(d);
      }

      // If matches the `Year` format
      if (yearCondition.map(isValidDate).includes(true)) {
        return __WEBPACK_IMPORTED_MODULE_0_moment___default()(d, 'YYYY-MM-DD');
      }

      // If matches the `noYear` format
      if (noYearCondition.map(isValidDate).includes(true)) {
        return __WEBPACK_IMPORTED_MODULE_0_moment___default()(d, 'MM-DD').isBefore(getToday()) ? __WEBPACK_IMPORTED_MODULE_0_moment___default()(d, 'M-D').add(1, 'year') : __WEBPACK_IMPORTED_MODULE_0_moment___default()(d, 'M-D');
      }

      // Match 今天, 明天, 大後天 .. etc.., get the offset against today
      var v = function () {

        v = __WEBPACK_IMPORTED_MODULE_2__static_periods_json___default.a.find(function (period) {
          return period.dateDefine == d;
        });

        // Find no result, return `add 0 days` (today)
        return v ? v.dateValue : 0;
      }();

      return __WEBPACK_IMPORTED_MODULE_0_moment___default()().add(v, 'DAYS');
    }();

    return {
      'date': m.format('YYYY-MM-DD'),
      'humanize': m.format('YYYY年MM月DD日 (dddd)'),
      'today': __WEBPACK_IMPORTED_MODULE_0_moment___default()(getToday()).isSame(m.format('YYYY-MM-DD'))
    };
  },

  /**
   * Check if the train has departured
   */
  isDeparture: function isDeparture(departure) {

    var today = __WEBPACK_IMPORTED_MODULE_0_moment___default()().format('YYYY-MM-DD');
    var now = __WEBPACK_IMPORTED_MODULE_0_moment___default()().format('HH:mm');

    return __WEBPACK_IMPORTED_MODULE_0_moment___default()(now, 'HH:mm').isAfter(__WEBPACK_IMPORTED_MODULE_0_moment___default()(departure, 'HH:mm')) ? true : false;
  },

  /**
   * Determine if the train is delay.
   * t: TrainNo, delayInfo: Delay info given from component
   */
  isDelay: function isDelay(t, delayInfo, wantsColor) {

    return function () {

      var r = delayInfo.find(function (delay) {
        return delay.TrainNo == t;
      });

      // Check if find a train
      r = r ? r.DelayTime : false;

      if (!wantsColor) {
        return Number(r) === 0 ? null : r;
      }

      // Otherwise wants color...
      if (r !== false) {
        return Number(r) === 0 ? 'green' : 'yellow';
      }

      // Find nothing
      return false;
    }();
  },

  /**
   * Time subtract, return difference (string)
   * Use moment.js, and strip `0小時` from the result.
   */
  timeDiff: function timeDiff(s, e) {

    // Create a moment object that contains time difference.
    var timeObject = __WEBPACK_IMPORTED_MODULE_0_moment___default.a.utc(__WEBPACK_IMPORTED_MODULE_0_moment___default()(e, 'HH:mm').diff(__WEBPACK_IMPORTED_MODULE_0_moment___default()(s, 'HH:mm')));

    var r = {
      // Sort
      value: timeObject.format('HH:mm'),
      // Display
      humanize: timeObject.format('H[小時]m[分鐘]').replace(/^0小時/g, '')

      // Handle `Invalid date`. Avoid to display.
    };return timeObject == 'Invalid date' ? '' : r;
  },

  /**
   * Trim train class description
   */
  trainClassZH: function trainClassZH(t, wantsColor) {

    // If TRA left train class name blank, use English name instead
    t = t.Zh_tw ? t.Zh_tw : t.En;

    var r = t.replace(/自強\(普悠瑪\)/g, '普悠瑪').replace(/自強\(太魯閣\)/g, '太魯閣').replace(/自強\(DMU2800、2900、3000型柴聯及 EMU型電車自強號\)/g, '自強').replace(/區間快/g, '區間快車').replace(/.*(Chu-Kuang).*/g, '莒光').replace(/.*(Tze-Chiang).*/g, '自強').replace(/\(.+\)/g, '') || '其他';

    if (wantsColor) {

      return __WEBPACK_IMPORTED_MODULE_5__static_trainclasses_json___default.a.find(function (trainClass) {
        return trainClass.classDesc == r;
      }).classColor;
    }

    return r;
  },

  /**
   * Transform `TrainTypeID` into train class
   * wantsColor[Boolean] determine if the call wants color.
   */
  trainClass: function trainClass() {
    var c = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var wantsColor = arguments[1];


    var testField = function testField() {
      return wantsColor ? 'classColor' : 'classDesc';
    };

    return __WEBPACK_IMPORTED_MODULE_5__static_trainclasses_json___default.a.find(function (trainClass) {
      return trainClass.classNo == c;
    })[testField()];
  },

  /**
   * Return Trip Lines description
   */
  tripLine: function tripLine() {
    var l = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var wantsColor = arguments[1];

    if (wantsColor) {
      return _.get(__WEBPACK_IMPORTED_MODULE_3__static_triplines_json___default.a, l).lineColor;
    }

    return _.get(__WEBPACK_IMPORTED_MODULE_3__static_triplines_json___default.a, l).lineDesc;
  },

  /**
   * Return TRUE if the DMU note exists.
   */
  DMULabel: function DMULabel(n) {
    return (/柴聯自強號(，|。)/ig.test(n)
    );
  },

  // *********************************
  //  Requests
  // *********************************

  /**
   * Get live board information (delay information)
   */
  getLiveboard: function getLiveboard(station) {

    return axios.get("https://benyi.tw/trainfo-api/public/" + '/LiveBoard/' + station);
  },

  /**
   * Get daily timetable with Origin and Destination
   */
  searchTimetableBetweenOriginAndDestination: function searchTimetableBetweenOriginAndDestination(keyword) {
    return axios.get("https://benyi.tw/trainfo-api/public/" + 'api/search?keyword=' + keyword);
  },

  /**
   * Get the fares between startStation and destStation
   */
  getODFare: function getODFare(start, dest) {

    return axios.get("https://benyi.tw/trainfo-api/public/" + '/ODFare/' + start + '/to/' + dest);
  },

  /**
   * Get the specific train information by TrainNo
   */
  searchTimetableByTrainNo: function searchTimetableByTrainNo(trainNo, date) {

    var query = new URLSearchParams({
      no: trainNo,
      date: date
    }).toString();

    return axios.get("https://benyi.tw/trainfo-api/public/" + 'api/train?' + query);
  },

  /**
   * 特定車站的所有列車
   */
  getTimetableByStationNo: function getTimetableByStationNo(stationNo) {
    var date = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    var toBuild = _.pickBy({
      no: stationNo,
      date: date
    });

    var query = new URLSearchParams(toBuild).toString();

    return axios.get("https://benyi.tw/trainfo-api/public/" + 'api/station/timetable?' + query);
  },

  /**
   * 是否為跨日列車
   */
  overNightLabel: function overNightLabel(OverNightStationID) {
    return OverNightStationID !== "";
  },

  /**
   * 車種顏色
   */
  trainTypeColor: function trainTypeColor(typeCode) {
    var typeColors = {
      /** 太魯閣 */"1": "blue",
      /** 普悠瑪 */"2": "pink",
      /** 自強 */"3": "red",
      /** 莒光 */"4": "orange",
      /** 區間快 */"10": "grey"
    };

    return _.get(typeColors, typeCode, "");
  }
});

/***/ }),

/***/ "ue78":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "unId":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-il": "QZk1",
	"./en-il.js": "QZk1",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mn": "CqHt",
	"./mn.js": "CqHt",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./mt": "oCzW",
	"./mt.js": "oCzW",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./tg": "5SNd",
	"./tg.js": "5SNd",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./ug-cn": "To0v",
	"./ug-cn.js": "To0v",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "wRmV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d2516f8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Loading_vue__ = __webpack_require__("WPd6");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d2516f8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Loading_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "wtKx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44ba4ecc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchError_vue__ = __webpack_require__("n4jg");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44ba4ecc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchError_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wybN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',[_c('h3',{staticClass:"ui header",class:_vm.trainTypeColor(_vm.train.TrainInfo.TrainTypeCode)},[_vm._v("\n      "+_vm._s(_vm.getName(_vm.train))+"\n      "),_c('div',{staticClass:"sub header"},[_vm._v(_vm._s(_vm.train.TrainInfo.TrainNo))])])]),_vm._v(" "),_c('td',{staticClass:"center aligned"},[(_vm.train.TrainInfo.TripLine != 0)?_c('div',{staticClass:"ui circular basic label",class:[_vm.tripLine(_vm.train.TrainInfo.TripLine, true)]},[_vm._v(_vm._s(_vm.tripLine(_vm.train.TrainInfo.TripLine)))]):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"center aligned departure-time"},[_vm._v(_vm._s(_vm.train.TrainInfo.DepartureTime))]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('td',{staticClass:"center aligned"},[_c('h5',{staticClass:"ui header"},[_vm._v("\n      "+_vm._s(_vm._.get(_vm.train, 'TrainInfo.EndingStationName.Zh_tw', '未知'))+"\n      "),_c('div',{staticClass:"sub header"},[_vm._v("\n        "+_vm._s(_vm._.get(_vm.train, 'TrainInfo.EndingStationName.En', 'Unknown'))+"\n      ")])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"center aligned"},[_c('h5',{staticClass:"ui trip icon header"},[_c('i',{staticClass:"arrow right icon"}),_vm._v(" "),_c('div',{staticClass:"sub header"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Google Analytics
(function (i, s, o, g, r, a, m) {
  i['GoogleAnalyticsObject'] = r;
  i[r] = i[r] || function () {
    (i[r].q = i[r].q || []).push(arguments);
  }, i[r].l = 1 * new Date();
  a = s.createElement(o), m = s.getElementsByTagName(o)[0];
  a.async = 1;
  a.src = g;
  m.parentNode.insertBefore(a, m);
})(window, document, 'script', 'https://www.google-analytics.com/analytics.js', 'ga');

ga('create', 'UA-40661556-5', 'auto');
ga('send', 'pageview');

// Facebook JavaScript SDK
(function (d, s, id) {
  var js,
      fjs = d.getElementsByTagName(s)[0];
  if (d.getElementById(id)) return;
  js = d.createElement(s);
  js.id = id;
  js.src = "//connect.facebook.net/zh_TW/sdk.js#xfbml=1&version=v2.8";
  fjs.parentNode.insertBefore(js, fjs);
})(document, 'script', 'facebook-jssdk');

/**
 * Trun off Mobile Device scale over 1
 */
document.addEventListener('touchmove', function (event) {
  if (event.scale !== 1) {
    event.preventDefault();
  }
}, false);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app'
});

/***/ }),

/***/ "xpqj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui grid stackable container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"ui sixteen wide column"},[_c('h3',{staticClass:"header"},[_vm._v("\n        關於本站\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        No bullshit.\n      ")]),_vm._v(" "),_c('h3',{staticClass:"header"},[_vm._v("目的是什麼")]),_vm._v(" "),_c('p',[_vm._v("速度快，直覺的時刻表查詢方式。")]),_vm._v(" "),_c('h3',{staticClass:"header"},[_vm._v("使用方法")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('h3',{staticClass:"header"},[_vm._v("\n        資料來源\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        交通部開放資料平台 + 自行整理\n      ")]),_vm._v(" "),_c('h3',{staticClass:"header"},[_vm._v("\n        關於本專案\n      ")]),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('h3',{staticClass:"header"},[_vm._v("\n        更新狀態\n      ")]),_vm._v(" "),(_vm.status)?_c('p',[_vm._v("\n        最近更新日期："+_vm._s(_vm.moment(_vm.status.committer.date).format('YYYY年MM月DD日 HH:mm'))+" ( "+_vm._s(_vm.moment(_vm.status.committer.date).fromNow())+" )\n        "),_c('br'),_vm._v(" 更新訊息："+_vm._s(_vm.status.message)+"\n      ")]):_c('p',[_vm._v("\n        取得更新資訊中...\n      ")])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("\n        格式："),_c('b',[_vm._v("起站 迄站 [時間] [車種]")]),_vm._v(" "),_c('i',[_vm._v("(空白分隔)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("\n        「中壢 臺北」「高雄 台南」「民雄 嘉義」「斗六 員林」\n        "),_c('br'),_vm._v(" 「臺北 桃園 明天」「民雄 嘉義 星期六」「斗六 員林 12/8」「汐止 基隆 12月8日」\n        "),_c('br'),_vm._v(" 「108 102」「115 板橋 11/26」「桃園 108 明天」\n        "),_c('br'),_vm._v(" 「桃園 板橋 自強」「高雄 嘉義 明天 莒光號」「新竹 彰化 對號車」\n        "),_c('br'),_vm._v(" 「taitng tapei」「鳳山 新左」「鳳 高」\n      ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("\n        時間支援：「星期六」「週六」「12/8」「12-8」「12月8日」「今天」「明天」「大後天」\n        "),_c('br'),_vm._v(" 車站查詢：請用全名或車站代碼，亦可進行模糊搜尋(「高 鳳」「新左 tapei」)，但是沒有簡稱 (北車、高火)\n        "),_c('br'),_vm._v(" 車種支援：「莒光號」「自強號」「區間車」「傾斜式」「對號」「站票」.....\n      ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("\n        Author: "),_c('a',{attrs:{"href":"http://benyi.tw","target":"_blank"}},[_vm._v("Benyi")]),_vm._v(" "),_c('br'),_vm._v(" Github: "),_c('a',{attrs:{"href":"https://github.com/banqhsia/tra-info","target":"_blank"}},[_vm._v("https://github.com/banqhsia/tra-info")]),_vm._v(" "),_c('br'),_vm._v(" Email: banqhsia _AT_ msn.com\n        "),_c('br'),_vm._v(" 如果有任何問題，歡迎來信詢問\n        "),_c('br'),_vm._v(" 本站資料僅供參考，詳細以臺鐵公告及現場狀況為準\n      ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.e8e7b5f0de3dd2df16da.js